import { Interface } from "readline";
import { string } from "yargs";
import { FC } from "react";
import { colorforChart } from "../../redux/actions/getTerminalsTransactionChart";

interface ClockProps {
  color?: string;
  width?: string;
  height?: string;
  className?: string;
}

export const DownIcon2 = () => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.50085 4.84613L7.00085 8.0769L10.5009 4.84613"
        stroke="black"
        strokeWidth="1.07692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UpIcon = () => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(180)"
    >
      <path
        d="M3.50085 4.84613L7.00085 8.0769L10.5009 4.84613"
        stroke="black"
        strokeWidth="1.07692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckedTrue = ({ color }: any) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0001 29.3333C23.3334 29.3333 29.3334 23.3333 29.3334 16C29.3334 8.66667 23.3334 2.66667 16.0001 2.66667C8.66675 2.66667 2.66675 8.66667 2.66675 16C2.66675 23.3333 8.66675 29.3333 16.0001 29.3333Z"
        fill={color}
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3333 16L14.1066 19.7733L21.6666 12.2267"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserIcon = ({ color }: any) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 7.96875C5.51875 7.96875 3.90625 6.35625 3.90625 4.375C3.90625 2.39375 5.51875 0.78125 7.5 0.78125C9.48125 0.78125 11.0938 2.39375 11.0938 4.375C11.0938 6.35625 9.48125 7.96875 7.5 7.96875ZM7.5 1.71875C6.0375 1.71875 4.84375 2.9125 4.84375 4.375C4.84375 5.8375 6.0375 7.03125 7.5 7.03125C8.9625 7.03125 10.1562 5.8375 10.1562 4.375C10.1562 2.9125 8.9625 1.71875 7.5 1.71875Z"
        fill={color}
        stroke="#001C12"
        strokeWidth="0.4"
      />
      <path
        d="M12.8703 14.2188C12.6141 14.2188 12.4016 14.0062 12.4016 13.75C12.4016 11.5938 10.2016 9.84375 7.50156 9.84375C4.80156 9.84375 2.60156 11.5938 2.60156 13.75C2.60156 14.0062 2.38906 14.2188 2.13281 14.2188C1.87656 14.2188 1.66406 14.0062 1.66406 13.75C1.66406 11.0812 4.28281 8.90625 7.50156 8.90625C10.7203 8.90625 13.3391 11.0812 13.3391 13.75C13.3391 14.0062 13.1266 14.2188 12.8703 14.2188Z"
        fill={color}
        stroke="#001C12"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export const CustomersIcon = ({ color }: any) => {
  return (
    <svg
      stroke={color}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.27796 10.5864C9.18213 10.5768 9.06713 10.5768 8.96171 10.5864C6.68088 10.5097 4.86963 8.64094 4.86963 6.34094C4.86963 3.99302 6.76713 2.08594 9.12463 2.08594C11.4725 2.08594 13.3796 3.99302 13.3796 6.34094C13.37 8.64094 11.5588 10.5097 9.27796 10.5864Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2266 4.00391C18.0858 4.00391 19.5808 5.50849 19.5808 7.35807C19.5808 9.16932 18.1433 10.6452 16.3512 10.7122C16.2746 10.7027 16.1883 10.7027 16.1021 10.7122"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.48645 14.1239C2.16728 15.6764 2.16728 18.2064 4.48645 19.7493C7.12186 21.5127 11.4439 21.5127 14.0794 19.7493C16.3985 18.1968 16.3985 15.6668 14.0794 14.1239C11.4535 12.3702 7.13145 12.3702 4.48645 14.1239Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0757 19.3359C18.7657 19.1922 19.4173 18.9143 19.954 18.5022C21.449 17.3809 21.449 15.5314 19.954 14.4101C19.4269 14.0076 18.7849 13.7393 18.1044 13.5859"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LanguageIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49935 15.5833C12.4114 15.5833 15.5827 12.412 15.5827 8.49999C15.5827 4.58797 12.4114 1.41666 8.49935 1.41666C4.58733 1.41666 1.41602 4.58797 1.41602 8.49999C1.41602 12.412 4.58733 15.5833 8.49935 15.5833Z"
        stroke="#001C12"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66549 2.125H6.37383C4.99258 6.26167 4.99258 10.7383 6.37383 14.875H5.66549"
        stroke="#001C12"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.625 2.125C12.0062 6.26167 12.0062 10.7383 10.625 14.875"
        stroke="#001C12"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.125 11.3333V10.625C6.26167 12.0062 10.7383 12.0062 14.875 10.625V11.3333"
        stroke="#001C12"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.125 6.37499C6.26167 4.99374 10.7383 4.99374 14.875 6.37499"
        stroke="#001C12"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmailTHin = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.041 14.521H4.95768C2.83268 14.521 1.41602 13.4585 1.41602 10.9793V6.02098C1.41602 3.54181 2.83268 2.47931 4.95768 2.47931H12.041C14.166 2.47931 15.5827 3.54181 15.5827 6.02098V10.9793C15.5827 13.4585 14.166 14.521 12.041 14.521Z"
        stroke="#001C12"
        strokeWidth="1.1875"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0423 6.375L9.82523 8.14583C9.09565 8.72667 7.89856 8.72667 7.16898 8.14583L4.95898 6.375"
        stroke="#001C12"
        strokeWidth="1.1875"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PasswordIcon = ({ color = "#001C12" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_810_7077)">
        <path
          d="M3.30578 14.1752C3.47152 15.4062 4.49114 16.3706 5.73193 16.4276C6.776 16.4756 7.83659 16.5007 9.00455 16.5007C10.1725 16.5007 11.2331 16.4756 12.2772 16.4276C13.518 16.3706 14.5376 15.4062 14.7033 14.1752C14.8115 13.3718 14.9007 12.5485 14.9007 11.7101C14.9007 10.8716 14.8115 10.0483 14.7033 9.24492C14.5376 8.01392 13.518 7.04951 12.2772 6.99247C11.2331 6.94447 10.1725 6.91943 9.00455 6.91943C7.8366 6.91943 6.776 6.94447 5.73193 6.99247C4.49114 7.04951 3.47152 8.01392 3.30578 9.24492C3.19761 10.0483 3.1084 10.8716 3.1084 11.7101C3.1084 12.5485 3.19761 13.3718 3.30578 14.1752Z"
          stroke={color}
          strokeWidth="1.65829"
        />
        <path
          d="M5.6875 6.91944V5.0769C5.6875 3.2452 7.17238 1.76031 9.00408 1.76031C10.8358 1.76031 12.3207 3.2452 12.3207 5.0769V6.91944"
          stroke={color}
          strokeWidth="1.65829"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.00195 11.7101H9.00857"
          stroke={color}
          strokeWidth="2.21106"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_810_7077">
          <rect
            width="17.6884"
            height="17.6884"
            fill="white"
            transform="translate(0.160156 0.286316)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Clock: FC<ClockProps> = ({ width, height, color, className }) => {
  return (
    <svg
      className={className}
      width={width ? width : "14"}
      height={height ? height : "14"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="7.14079"
        cy="7.00016"
        r="5.41667"
        stroke={color ? color : "black"}
        strokeWidth="0.8125"
      />
      <path
        d="M7.14111 4.8335V6.85522C7.14111 6.94577 7.18637 7.03033 7.26172 7.08056L8.76611 8.0835"
        stroke={color ? color : "black"}
        strokeWidth="0.8125"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DownloadIcon = ({ color }: any) => {
  //#001C12
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.41704 8.31818V12.4097L7.78087 11.0458"
        stroke={color}
        strokeWidth="1.02287"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41742 12.4095L5.05359 11.0457"
        stroke={color}
        strokeWidth="1.02287"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2824 7.63623V11.0458C15.2824 14.4554 13.9186 15.8192 10.509 15.8192H6.4175C3.00793 15.8192 1.64409 14.4554 1.64409 11.0458V6.95432C1.64409 3.54474 3.00793 2.18091 6.4175 2.18091H9.82708"
        stroke={color}
        strokeWidth="1.02287"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2819 7.63623H12.5542C10.5085 7.63623 9.82654 6.95432 9.82654 4.90857V2.18091L15.2819 7.63623Z"
        stroke={color}
        strokeWidth="1.02287"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OpenEyeIcon = () => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.8922 11.5531C2.65051 11.1112 2.65052 10.5771 2.89221 10.1352C4.42801 7.32695 7.41333 5.42188 10.8444 5.42188C14.2755 5.42188 17.2609 7.32701 18.7967 10.1353C19.0384 10.5772 19.0384 11.1113 18.7967 11.5532C17.2609 14.3615 14.2756 16.2665 10.8445 16.2665C7.41334 16.2665 4.42798 14.3614 2.8922 11.5531Z"
        stroke="#8B97A3"
        strokeWidth="1.35558"
      />
      <circle
        cx="10.844"
        cy="10.844"
        r="2.71117"
        stroke="#8B97A3"
        strokeWidth="1.35558"
      />
    </svg>
  );
};
export const CloseEyeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1092 7.8916L7.89258 12.1083C7.35091 11.5666 7.01758 10.8249 7.01758 9.99993C7.01758 8.34993 8.35091 7.0166 10.0009 7.0166C10.8259 7.0166 11.5676 7.34994 12.1092 7.8916Z"
        stroke="#8B97A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8499 4.8084C13.3915 3.7084 11.7249 3.1084 9.99987 3.1084C7.0582 3.1084 4.31654 4.84173 2.4082 7.84173C1.6582 9.01673 1.6582 10.9917 2.4082 12.1667C3.06654 13.2001 3.8332 14.0917 4.66654 14.8084"
        stroke="#8B97A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.01758 16.2751C7.96758 16.6751 8.97591 16.8917 10.0009 16.8917C12.9426 16.8917 15.6842 15.1584 17.5926 12.1584C18.3426 10.9834 18.3426 9.0084 17.5926 7.8334C17.3176 7.40006 17.0176 6.99173 16.7092 6.6084"
        stroke="#8B97A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9242 10.583C12.7076 11.758 11.7492 12.7163 10.5742 12.933"
        stroke="#8B97A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.89102 12.1084L1.66602 18.3334"
        stroke="#8B97A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3324 1.66699L12.1074 7.89199"
        stroke="#8B97A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PrevIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 19 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6955 14.6024L5.2393 9.68011C5.0057 9.47988 5.0057 9.11279 5.2393 8.91256L10.6955 3.99028C11.0459 3.67325 11.6132 3.90685 11.6132 4.37405L11.6132 14.2186C11.6132 14.6858 11.0459 14.9194 10.6955 14.6024Z"
          fill="#ABAFB1"
        />
      </svg>
    </>
  );
};

export const NextIcon = ({ color = "#ABAFB1" }) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 19 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.30446 3.9903L11.7607 8.91258C11.9943 9.11281 11.9943 9.4799 11.7607 9.68013L6.30446 14.6024C5.95406 14.9194 5.38674 14.6858 5.38674 14.2186L5.38674 4.37407C5.38674 3.90687 5.95406 3.67327 6.30446 3.9903Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export const EditIcon = () => {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4377 3.12094L4.28019 9.63844C4.04769 9.88594 3.82269 10.3734 3.77769 10.7109L3.50019 13.1409C3.40269 14.0184 4.03269 14.6184 4.90269 14.4684L7.31769 14.0559C7.65519 13.9959 8.12769 13.7484 8.36019 13.4934L14.5177 6.97594C15.5827 5.85094 16.0627 4.56844 14.4052 3.00094C12.7552 1.44844 11.5027 1.99594 10.4377 3.12094Z"
          stroke="#001C12"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.41016 4.20874C9.73266 6.27874 11.4127 7.86124 13.4977 8.07124"
          stroke="#001C12"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.74414 16.921H16.2441"
          stroke="#001C12"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const CalendarIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="2"
          y="2.33337"
          width="12"
          height="12"
          rx="3.33333"
          stroke="#001C12"
        />
        <path d="M2 5.66671H14" stroke="#001C12" strokeLinejoin="round" />
        <path d="M2 5.66671H14" stroke="#001C12" strokeLinejoin="round" />
        <path
          d="M11 1.33337L11 3.33337"
          stroke="#001C12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 1.33337L5 3.33337"
          stroke="#001C12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.33398 8.33341H5.00065"
          stroke="#001C12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.66732 8.33341H8.33398"
          stroke="#001C12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0007 8.33341H11.6673"
          stroke="#001C12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.33398 11H5.00065"
          stroke="#001C12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.66732 11H8.33398"
          stroke="#001C12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0007 11H11.6673"
          stroke="#001C12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const FilterIconWhite = () => {
  return (
    <>
      <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.55273 3.53443C1.55273 2.76465 2.17676 2.14062 2.94654 2.14062H14.097C14.8668 2.14062 15.4908 2.76465 15.4908 3.53443V4.10416C15.4908 4.63372 15.2898 5.14355 14.9285 5.53068L10.9873 9.75337C10.7464 10.0115 10.6125 10.3514 10.6125 10.7044V13.5573C10.6125 13.8212 10.4633 14.0625 10.2272 14.1806L7.43962 15.5744C6.97625 15.8061 6.43105 15.4691 6.43105 14.9511V10.7044C6.43105 10.3514 6.29708 10.0115 6.0562 9.75337L2.11502 5.53068C1.75369 5.14355 1.55273 4.63372 1.55273 4.10416V3.53443Z"
          stroke="white"
          strokeWidth="1.5"
        />
      </svg>
    </>
  );
};

export const DownIconWhite = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="20"
          height="20"
          transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 20 20)"
          fill="#001C12"
        />
        <path
          d="M4.16666 7.5L9.3492 11.9422C9.72369 12.2632 10.2763 12.2632 10.6508 11.9422L15.8333 7.5"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};

export const PlusIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 12H18"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 18V6"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const VerifyTrustIcon = () => {
  return (
    <svg
      width="86"
      height="109"
      viewBox="0 0 86 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_154_103)">
        <path
          d="M43.0001 108.998C60.2749 108.998 74.2789 107.325 74.2789 105.261C74.2789 103.197 60.2749 101.524 43.0001 101.524C25.7252 101.524 11.7212 103.197 11.7212 105.261C11.7212 107.325 25.7252 108.998 43.0001 108.998Z"
          fill="#EEF2F5"
        />
        <path
          d="M44.7804 95.7047L53.651 90.8637C73.5759 79.9928 86 58.912 86 35.9811V12.8322C86 11.0305 84.5916 9.53389 82.8137 9.48546C61.8499 8.9091 48.8461 2.77739 44.5654 0.404142C43.5919 -0.135894 42.4106 -0.135894 41.437 0.404142C37.1563 2.77739 24.1501 8.9091 3.18635 9.48546C1.40837 9.53389 0 11.0305 0 12.8322V35.9835C0 58.9145 12.4241 79.9928 32.349 90.8661L41.2196 95.7071C42.3308 96.3125 43.6692 96.3125 44.7804 95.7071V95.7047Z"
          fill="#EEF2F5"
        />
        <path
          d="M81.7483 15.5569V35.2016C81.7483 57.0694 69.9572 77.0871 50.9768 87.4446L44.6838 90.8761C44.1596 91.1619 43.5798 91.3072 43 91.3072C42.4202 91.3072 41.8405 91.1619 41.3163 90.8761L35.0233 87.4446C16.0429 77.0871 4.25171 57.0694 4.25171 35.2016V15.5569C4.25171 14.627 4.98609 13.8666 5.9089 13.8012C23.766 12.5831 36.0282 7.84141 42.2318 4.8022C42.4782 4.6787 42.7391 4.62057 43 4.62057C43.2609 4.62057 43.5194 4.68112 43.7682 4.8022C49.9718 7.84141 62.2365 12.5831 80.0911 13.8012C81.0164 13.8666 81.7483 14.627 81.7483 15.5569Z"
          fill="#77E5C0"
        />
        <path
          d="M81.7483 15.5569V35.2016C81.7483 57.0694 69.9571 77.0871 50.9767 87.4446L44.6838 90.8761C44.1596 91.1619 43.5798 91.3072 43 91.3072V4.62057C43.2609 4.62057 43.5194 4.68112 43.7682 4.8022C49.9718 7.84141 62.2365 12.5831 80.0911 13.8012C81.0163 13.8666 81.7483 14.627 81.7483 15.5569Z"
          fill="#00E6A0"
        />
        <path
          d="M57.736 40.1927H28.2665C26.5127 40.1927 25.0874 41.6215 25.0874 43.3796V66.9353C25.0874 68.6935 26.5127 70.1223 28.2665 70.1223H57.736C59.4898 70.1223 60.9151 68.6935 60.9151 66.9353V43.3796C60.9151 41.6215 59.4898 40.1927 57.736 40.1927ZM45.8434 56.6504V59.0043C45.8434 60.5784 44.5703 61.8547 43 61.8547C41.4298 61.8547 40.1567 60.5784 40.1567 59.0043V56.6504C38.9489 55.7714 38.1662 54.345 38.1662 52.7346C38.1662 50.0586 40.3307 47.8888 43 47.8888C45.6694 47.8888 47.8339 50.0586 47.8339 52.7346C47.8339 54.345 47.0512 55.7738 45.8434 56.6504Z"
          fill="white"
        />
        <path
          d="M53.5205 31.3657V35.0587C53.5205 36.318 52.501 37.34 51.2449 37.34C49.9887 37.34 48.9692 36.318 48.9692 35.0587V31.511C48.9692 28.2683 46.4593 25.5052 43.227 25.3817C39.8305 25.2533 37.0259 27.985 37.0259 31.3632V37.909H32.4771V31.5352C32.4771 25.7885 36.9945 20.9645 42.727 20.8192C45.7418 20.7442 48.4716 21.9356 50.438 23.9069C52.344 25.8176 53.5205 28.4499 53.5205 31.3632V31.3657Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_154_103">
          <rect width="86" height="109" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ApplePayIcon = () => {
  return (
    <svg
      width="50"
      height="18"
      viewBox="0 0 50 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.12888 2.64543C8.83257 3.01072 8.45776 3.30455 8.03229 3.50509C7.60682 3.70563 7.14164 3.80772 6.67129 3.80378C6.6167 2.87111 6.93162 1.95447 7.54789 1.25227C8.16986 0.535485 9.04478 0.0868041 9.98982 0C10.0272 0.475895 9.97044 0.954496 9.82271 1.40842C9.67498 1.86235 9.43921 2.2827 9.12888 2.64543ZM9.98982 3.99162C8.62797 3.91336 7.46962 4.75865 6.85913 4.75865C6.24865 4.75865 5.29379 4.03859 4.13544 4.05424C3.43106 4.06835 2.74263 4.26648 2.13851 4.62895C1.53439 4.99143 1.03561 5.50563 0.691681 6.12049C-0.764088 8.6407 0.315999 12.3819 1.74046 14.4325C2.42921 15.4343 3.30581 16.5613 4.35459 16.5144C5.40337 16.4674 5.7947 15.8413 7.04698 15.8413C8.29925 15.8413 8.61232 16.5144 9.75502 16.4987C10.8977 16.4831 11.6021 15.4812 12.3065 14.4638C12.7929 13.7448 13.1725 12.9592 13.4336 12.1314C12.7797 11.8482 12.2227 11.3805 11.8307 10.7855C11.4386 10.1905 11.2287 9.4941 11.2264 8.78158C11.2377 8.152 11.407 7.53536 11.7188 6.98831C12.0306 6.44126 12.475 5.98137 13.0109 5.65089C12.6658 5.16494 12.2142 4.76426 11.6906 4.47941C11.167 4.19456 10.5853 4.03308 9.98982 4.00728M17.8165 1.17401V16.4361H20.2585V11.1766H23.53C24.2013 11.2142 24.8731 11.1111 25.5021 10.8737C26.1312 10.6364 26.7036 10.2701 27.1827 9.79833C27.6618 9.32661 28.0369 8.75991 28.284 8.13461C28.5311 7.50931 28.6447 6.83924 28.6174 6.16745C28.6486 5.50136 28.5405 4.83608 28.2998 4.21421C28.0591 3.59233 27.6912 3.02755 27.2197 2.55604C26.7482 2.08452 26.1834 1.71665 25.5616 1.47597C24.9397 1.23529 24.2744 1.12711 23.6083 1.15835L17.8165 1.17401ZM20.2585 3.16199H22.9196C23.338 3.10256 23.7644 3.1375 24.1676 3.26424C24.5708 3.39099 24.9406 3.60633 25.2497 3.8945C25.5589 4.18266 25.7997 4.53634 25.9545 4.92964C26.1092 5.32293 26.1741 5.74587 26.1442 6.16745C26.1735 6.59163 26.1081 7.01702 25.9526 7.41276C25.7972 7.8085 25.5555 8.16467 25.2453 8.45543C24.9351 8.74618 24.564 8.96423 24.159 9.09374C23.754 9.22326 23.3253 9.261 22.9039 9.20422H20.2585V3.16199ZM32.8751 16.4361C33.575 16.453 34.2667 16.2818 34.8779 15.9404C35.4891 15.599 35.9976 15.0999 36.3502 14.4951V16.4361H38.5417V8.81288C38.5417 6.60575 36.7885 5.19694 34.0805 5.19694C31.3724 5.19694 29.7601 6.63706 29.6505 8.60939H31.7794C31.9012 8.12247 32.1947 7.69594 32.606 7.40831C33.0173 7.12068 33.5187 6.99132 34.0178 7.04405C35.458 7.04404 36.2719 7.7328 36.2719 8.96942V9.79905L33.3134 9.98689C30.5741 10.1434 29.087 11.2705 29.087 13.2272C29.1026 13.6945 29.2159 14.1535 29.4196 14.5745C29.6233 14.9954 29.9129 15.3691 30.2698 15.6713C30.6266 15.9736 31.0428 16.1978 31.4915 16.3295C31.9402 16.4613 32.4115 16.4976 32.8751 16.4361ZM33.5013 14.636C32.249 14.636 31.4507 14.0255 31.4507 13.0706C31.4507 12.1158 32.2177 11.5053 33.6891 11.5053L36.3189 11.3331V12.194C36.312 12.548 36.2319 12.8967 36.0837 13.2183C35.9355 13.5398 35.7224 13.8272 35.4578 14.0624C35.1931 14.2976 34.8827 14.4756 34.546 14.5851C34.2093 14.6945 33.8536 14.7332 33.5013 14.6986V14.636ZM41.5158 20.459C43.8169 20.459 44.897 19.5824 45.8518 16.9214L50 5.33782H47.605L44.8187 14.3385L42.0324 5.33782H39.5122L43.5195 16.4361L43.3003 17.1092C43.2202 17.5693 42.973 17.9836 42.6061 18.2725C42.2391 18.5615 41.7784 18.7046 41.3123 18.6745H40.6079V20.506C40.9101 20.5276 41.2131 20.5329 41.5158 20.5217V20.459Z"
        fill="black"
      />
    </svg>
  );
};

export const ApplePayLogo = () => {
  return (
    <>
      <svg
        width="59"
        height="24"
        viewBox="0 0 59 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4665 3.11812C11.1254 3.5387 10.6938 3.877 10.204 4.10789C9.71411 4.33877 9.17852 4.45632 8.63699 4.45178C8.57413 3.37796 8.93672 2.32258 9.64625 1.51412C10.3623 0.688852 11.3697 0.172268 12.4577 0.0723267C12.5008 0.620244 12.4354 1.17128 12.2653 1.6939C12.0953 2.21653 11.8238 2.7005 11.4665 3.11812ZM12.4577 4.66805C10.8898 4.57794 9.55613 5.55115 8.85326 5.55115C8.15038 5.55115 7.05101 4.72212 5.71735 4.74014C4.90638 4.75639 4.11376 4.98451 3.41821 5.40183C2.72267 5.81916 2.14839 6.41118 1.75242 7.1191C0.0763286 10.0207 1.31988 14.3281 2.95992 16.689C3.75291 17.8425 4.76216 19.1401 5.96967 19.086C7.17717 19.0319 7.62773 18.311 9.06953 18.311C10.5113 18.311 10.8718 19.086 12.1874 19.068C13.503 19.05 14.3141 17.8965 15.1251 16.7251C15.685 15.8973 16.1221 14.9928 16.4227 14.0397C15.6699 13.7137 15.0285 13.1752 14.5772 12.4901C14.1258 11.8051 13.8841 11.0033 13.8815 10.1829C13.8945 9.45807 14.0894 8.74809 14.4484 8.11826C14.8074 7.48842 15.319 6.95892 15.9361 6.57843C15.5387 6.01894 15.0188 5.55761 14.4159 5.22965C13.8131 4.9017 13.1434 4.71577 12.4577 4.68607M21.469 1.42401V18.9959H24.2805V12.9404H28.0472C28.82 12.9837 29.5934 12.8649 30.3177 12.5917C31.042 12.3184 31.7011 11.8967 32.2526 11.3536C32.8042 10.8104 33.2361 10.158 33.5206 9.43804C33.8051 8.7181 33.9358 7.94663 33.9045 7.17317C33.9404 6.40627 33.8159 5.64031 33.5388 4.92431C33.2617 4.20832 32.8381 3.55807 32.2952 3.0152C31.7524 2.47232 31.1021 2.04878 30.3861 1.77167C29.6701 1.49457 28.9042 1.37002 28.1373 1.40599L21.469 1.42401ZM24.2805 3.71286H27.3443C27.8261 3.64443 28.317 3.68465 28.7813 3.83058C29.2455 3.97651 29.6712 4.22444 30.0271 4.55622C30.3831 4.888 30.6603 5.29521 30.8385 5.74802C31.0167 6.20083 31.0913 6.68778 31.0569 7.17317C31.0907 7.66154 31.0154 8.15131 30.8364 8.60694C30.6574 9.06258 30.3792 9.47265 30.022 9.80741C29.6648 10.1422 29.2376 10.3932 28.7713 10.5423C28.305 10.6914 27.8114 10.7349 27.3263 10.6695H24.2805V3.71286ZM38.8066 18.9959C39.6124 19.0153 40.4087 18.8183 41.1124 18.4252C41.8161 18.0321 42.4015 17.4574 42.8075 16.7611V18.9959H45.3307V10.219C45.3307 7.6778 43.3122 6.05578 40.1943 6.05578C37.0764 6.05578 35.2201 7.71384 35.0939 9.98467H37.545C37.6852 9.42407 38.0232 8.93298 38.4967 8.60182C38.9703 8.27065 39.5475 8.12172 40.1222 8.18243C41.7803 8.18243 42.7174 8.97541 42.7174 10.3992V11.3544L39.3112 11.5706C36.1573 11.7509 34.4451 13.0485 34.4451 15.3013C34.4631 15.8394 34.5936 16.3678 34.8281 16.8525C35.0626 17.3372 35.396 17.7674 35.8069 18.1154C36.2177 18.4634 36.6969 18.7215 37.2135 18.8732C37.7301 19.0248 38.2728 19.0666 38.8066 18.9959ZM39.5275 16.9233C38.0857 16.9233 37.1665 16.2204 37.1665 15.1211C37.1665 14.0217 38.0496 13.3188 39.7437 13.3188L42.7715 13.1206V14.1118C42.7635 14.5194 42.6713 14.9209 42.5007 15.2911C42.3301 15.6613 42.0847 15.9922 41.78 16.263C41.4754 16.5338 41.118 16.7387 40.7303 16.8647C40.3427 16.9908 39.9331 17.0352 39.5275 16.9954V16.9233ZM48.755 23.6277C51.4043 23.6277 52.6478 22.6184 53.7472 19.5546L58.5231 6.21798H55.7657L52.5577 16.5809L49.3497 6.21798H46.4481L51.0618 18.9959L50.8095 19.7709C50.7173 20.3006 50.4326 20.7776 50.0102 21.1102C49.5877 21.4429 49.0572 21.6077 48.5207 21.5731H47.7096V23.6817C48.0575 23.7066 48.4064 23.7127 48.755 23.6998V23.6277Z"
          fill="#8B97A3"
        />
      </svg>
    </>
  );
};

export const UserMngmtLogo = () => {
  return (
    <>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1586 11.0404C12.0586 11.0304 11.9386 11.0304 11.8286 11.0404C9.44859 10.9604 7.55859 9.01041 7.55859 6.61041C7.55859 4.16041 9.53859 2.17041 11.9986 2.17041C14.4486 2.17041 16.4386 4.16041 16.4386 6.61041C16.4286 9.01041 14.5386 10.9604 12.1586 11.0404Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.15875 14.7304C4.73875 16.3504 4.73875 18.9904 7.15875 20.6004C9.90875 22.4404 14.4188 22.4404 17.1688 20.6004C19.5888 18.9804 19.5888 16.3404 17.1688 14.7304C14.4288 12.9004 9.91875 12.9004 7.15875 14.7304Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const DeleteIcon = () => {
  return (
    <>
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.39086 5.00227C1.76187 4.16361 2.36027 2.9668 3.40859 2.9668H11.7201C12.7684 2.9668 13.3668 4.16361 12.7378 5.00227V5.00227C12.2791 5.61395 12.0311 6.35794 12.0311 7.12254V11.9002C12.0311 13.5448 10.6979 14.8781 9.05325 14.8781H6.07544C4.43083 14.8781 3.09762 13.5448 3.09762 11.9002V7.12254C3.09762 6.35794 2.84962 5.61395 2.39086 5.00227V5.00227Z"
          stroke="#001C12"
          strokeWidth="1.11668"
        />
        <path
          d="M9.05176 11.1542L9.05176 6.6875"
          stroke="#001C12"
          strokeWidth="1.11668"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.07617 11.1542L6.07617 6.6875"
          stroke="#001C12"
          strokeWidth="1.11668"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5425 2.96578L10.1374 1.7505C9.93479 1.14251 9.36582 0.732422 8.72495 0.732422H6.40451C5.76364 0.732422 5.19467 1.14251 4.99201 1.7505L4.58691 2.96578"
          stroke="#001C12"
          strokeWidth="1.11668"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};

export const CrossIcon = ({ color }: any) => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.67747 5.84945C6.54515 5.72615 6.37013 5.65903 6.18929 5.66222C6.00846 5.66541 5.83591 5.73867 5.70802 5.86656C5.58013 5.99445 5.50687 6.16699 5.50368 6.34783C5.50049 6.52867 5.56762 6.70368 5.69092 6.83601L9.15317 10.2983L5.69092 13.7605C5.62234 13.8244 5.56733 13.9015 5.52918 13.9871C5.49103 14.0727 5.47051 14.1652 5.46886 14.2589C5.4672 14.3526 5.48445 14.4457 5.51955 14.5326C5.55466 14.6195 5.60692 14.6985 5.6732 14.7648C5.73948 14.8311 5.81844 14.8833 5.90536 14.9184C5.99227 14.9535 6.08537 14.9708 6.1791 14.9691C6.27282 14.9675 6.36526 14.9469 6.45088 14.9088C6.5365 14.8706 6.61357 14.8156 6.67747 14.7471L10.1397 11.2848L13.602 14.7471C13.6659 14.8156 13.7429 14.8706 13.8286 14.9088C13.9142 14.9469 14.0066 14.9675 14.1003 14.9691C14.1941 14.9708 14.2872 14.9535 14.3741 14.9184C14.461 14.8833 14.54 14.8311 14.6062 14.7648C14.6725 14.6985 14.7248 14.6195 14.7599 14.5326C14.795 14.4457 14.8122 14.3526 14.8106 14.2589C14.8089 14.1652 14.7884 14.0727 14.7503 13.9871C14.7121 13.9015 14.6571 13.8244 14.5885 13.7605L11.1263 10.2983L14.5885 6.83601C14.7118 6.70368 14.7789 6.52867 14.7758 6.34783C14.7726 6.16699 14.6993 5.99445 14.5714 5.86656C14.4435 5.73867 14.271 5.66541 14.0901 5.66222C13.9093 5.65903 13.7343 5.72615 13.602 5.84945L10.1397 9.3117L6.67747 5.84945Z"
          fill={color}
          stroke={color}
        />
      </svg>
    </>
  );
};

export const SendNotification = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0449 12.8672H4.79492C2.91992 12.8672 1.66992 11.9297 1.66992 9.74219V5.36719C1.66992 3.17969 2.91992 2.24219 4.79492 2.24219H11.0449C12.9199 2.24219 14.1699 3.17969 14.1699 5.36719V9.74219C14.1699 11.9297 12.9199 12.8672 11.0449 12.8672Z"
          stroke="#001C12"
          strokeWidth="1.0625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0449 5.67969L9.08867 7.24219C8.44492 7.75469 7.38867 7.75469 6.74492 7.24219L4.79492 5.67969"
          stroke="#001C12"
          strokeWidth="1.0625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const CopyIcon = ({ color = "#000" }) => {
  return (
    <>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.7539 9.11628V11.1163C11.7539 13.7829 10.6872 14.8496 8.02057 14.8496H5.48724C2.82057 14.8496 1.75391 13.7829 1.75391 11.1163V8.58294C1.75391 5.91628 2.82057 4.84961 5.48724 4.84961H7.48724"
          stroke={color}
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.753 9.11628H9.61966C8.01966 9.11628 7.48633 8.58294 7.48633 6.98294V4.84961L11.753 9.11628Z"
          stroke={color}
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.15234 1.51562H10.819"
          stroke={color}
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.08594 3.51563C5.08594 2.40896 5.97927 1.51562 7.08594 1.51562H8.8326"
          stroke={color}
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0862 5.51758V9.64424C15.0862 10.6776 14.2462 11.5176 13.2129 11.5176"
          stroke={color}
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0859 5.51563H13.0859C11.5859 5.51563 11.0859 5.01563 11.0859 3.51563V1.51562L15.0859 5.51563Z"
          stroke={color}
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const NumberIcon = () => {
  return (
    <>
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.660156 5.14966C0.660156 4.82215 0.925662 4.55664 1.25318 4.55664H17.0671C17.3947 4.55664 17.6602 4.82215 17.6602 5.14966C17.6602 5.47718 17.3947 5.74269 17.0671 5.74269H1.25318C0.925662 5.74269 0.660156 5.47718 0.660156 5.14966Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.82422 11.4758C3.82422 11.1483 4.08972 10.8828 4.41724 10.8828H5.99864C6.32615 10.8828 6.59166 11.1483 6.59166 11.4758C6.59166 11.8034 6.32615 12.0689 5.99864 12.0689H4.41724C4.08972 12.0689 3.82422 11.8034 3.82422 11.4758Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.38281 11.4758C7.38281 11.1483 7.64832 10.8828 7.97584 10.8828H11.1386C11.4661 10.8828 11.7316 11.1483 11.7316 11.4758C11.7316 11.8034 11.4661 12.0689 11.1386 12.0689H7.97584C7.64832 12.0689 7.38281 11.8034 7.38281 11.4758Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.37286 2.31306C2.03677 2.64537 1.8462 3.277 1.8462 4.6677V11.1672C1.8462 12.5582 2.03688 13.1893 2.37246 13.5205C2.71022 13.8538 3.35389 14.0414 4.76221 14.0375L4.76388 14.0375L13.5564 14.0375C14.9647 14.0375 15.609 13.8486 15.9475 13.514C16.2835 13.1817 16.4741 12.55 16.4741 11.1593V4.6677C16.4741 3.27695 16.2835 2.64569 15.9469 2.31345C15.6075 1.9785 14.961 1.78956 13.5485 1.78956H4.76388C3.35565 1.78956 2.71129 1.97844 2.37286 2.31306ZM1.53896 1.46967C2.25413 0.762545 3.36513 0.603516 4.76388 0.603516H13.5485C14.951 0.603516 16.0638 0.76248 16.78 1.46928C17.4989 2.17878 17.6602 3.28311 17.6602 4.6677V11.1593C17.6602 12.544 17.4989 13.6479 16.7814 14.3574C16.0662 15.0645 14.9552 15.2235 13.5564 15.2235H4.76447C3.36631 15.2274 2.25503 15.0709 1.53936 14.3647C0.821342 13.6561 0.660156 12.5516 0.660156 11.1672V4.6677C0.660156 3.28305 0.821453 2.1791 1.53896 1.46967Z"
          fill="#001C12"
        />
      </svg>
    </>
  );
};

export const NationalId = () => {
  return (
    <>
      <svg
        width="25px"
        height="25px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            d="M18 12H15M21 8H3M18 16H15M13 19C12.6218 17.2883 10.9747 16 9 16C7.03262 16 5.39034 17.2788 5.00424 18.9811M9 12H9.01M5.00424 18.9811C5.31776 19 5.70396 19 6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.33038 18.9035 4.60979 18.9572 5.00424 18.9811ZM10 12C10 12.5523 9.55228 13 9 13C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11C9.55228 11 10 11.4477 10 12Z"
            stroke="#000000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </g>
      </svg>
    </>
  );
};

export const CardIcon = () => {
  return (
    <>
      <svg
        width="19"
        height="17"
        viewBox="0 0 19 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.160156 9.27043C0.160156 8.92368 0.441255 8.64258 0.788008 8.64258H15.0193C15.3661 8.64258 15.6472 8.92368 15.6472 9.27043C15.6472 9.61718 15.3661 9.89828 15.0193 9.89828H0.788008C0.441255 9.89828 0.160156 9.61718 0.160156 9.27043Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.33109 4.84198C2.3863 4.89845 1.99734 5.09474 1.79175 5.35413C1.5581 5.64892 1.41586 6.19496 1.41586 7.32068V13.1723C1.41586 14.4221 1.59023 14.9528 1.86314 15.2221C2.13896 15.4943 2.68364 15.6669 3.9524 15.6669H11.8549C13.1022 15.6669 13.6498 15.5013 13.9298 15.2379C14.1987 14.9849 14.3786 14.4885 14.3915 13.3029V7.32068C14.3915 6.07081 14.2171 5.54013 13.9442 5.27083C13.6683 4.99865 13.1237 4.82602 11.8549 4.82602H3.9524C3.73417 4.82602 3.52956 4.83373 3.33109 4.84198ZM3.27328 3.5876C3.4749 3.5792 3.70387 3.57031 3.9524 3.57031H11.8549C13.1143 3.57031 14.1518 3.7116 14.8262 4.37702C15.5034 5.0453 15.6472 6.07589 15.6472 7.32068V13.3128C15.6345 14.5107 15.4755 15.5078 14.7903 16.1525C14.1159 16.7869 13.0939 16.9226 11.8549 16.9226H3.9524C2.69302 16.9226 1.6555 16.7813 0.981158 16.1159C0.303913 15.4476 0.160156 14.417 0.160156 13.1723V7.32068C0.160156 6.18613 0.281608 5.23788 0.80766 4.57416C1.36139 3.87552 2.22705 3.64931 3.26239 3.58815L3.27328 3.5876Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.956 3.56949H11.8552C13.1146 3.56949 14.1521 3.71077 14.8265 4.37619C15.5037 5.04448 15.6475 6.07506 15.6475 7.31985V12.6019C16.1323 12.5094 16.3781 12.3544 16.5273 12.1662C16.7609 11.8714 16.9032 11.3253 16.9032 10.1996V4.34802C16.9032 3.09815 16.7288 2.56748 16.4559 2.29817C16.1801 2.026 15.6354 1.85336 14.3666 1.85336H6.46412C5.21681 1.85336 4.66919 2.01899 4.38919 2.2824C4.17561 2.48333 4.01815 2.83791 3.956 3.56949ZM3.52877 1.36781C4.20312 0.733397 5.22515 0.597656 6.46412 0.597656H14.3666C15.626 0.597656 16.6635 0.738944 17.3379 1.40436C18.0151 2.07265 18.1589 3.10323 18.1589 4.34802V10.1996C18.1589 11.3341 18.0374 12.2824 17.5114 12.9461C16.9576 13.6448 16.092 13.871 15.0566 13.9321C14.884 13.9423 14.7148 13.8809 14.5889 13.7622C14.4631 13.6436 14.3918 13.4783 14.3918 13.3054V7.31985C14.3918 6.06998 14.2174 5.53931 13.9445 5.27C13.6687 4.99783 13.124 4.82519 11.8552 4.82519H3.95272C3.73245 4.82519 3.52607 4.83305 3.32586 4.84139C3.15381 4.84856 2.98637 4.78475 2.86273 4.66489C2.73909 4.54504 2.6701 4.37966 2.67191 4.20747C2.68452 3.00959 2.84355 2.01246 3.52877 1.36781Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.88281 13.6239C2.88281 13.2772 3.16391 12.9961 3.51066 12.9961H4.95051C5.29727 12.9961 5.57836 13.2772 5.57836 13.6239C5.57836 13.9707 5.29727 14.2518 4.95051 14.2518H3.51066C3.16391 14.2518 2.88281 13.9707 2.88281 13.6239Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.11328 13.6239C6.11328 13.2772 6.39438 12.9961 6.74113 12.9961H9.62088C9.96763 12.9961 10.2487 13.2772 10.2487 13.6239C10.2487 13.9707 9.96763 14.2518 9.62088 14.2518H6.74113C6.39438 14.2518 6.11328 13.9707 6.11328 13.6239Z"
          fill="#001C12"
        />
      </svg>
    </>
  );
};

export const AmericanExLogo = () => {
  return (
    <>
      <svg
        width="50"
        height="28"
        viewBox="0 0 50 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.0001 14.5332H47.3993C46.6144 14.5332 46.0442 14.7215 45.6404 15.0144V14.5332H41.7934C41.1782 14.5332 40.4561 14.686 40.1146 15.0144V14.5332H33.2448V15.0144C32.6981 14.6192 31.7756 14.5332 31.3498 14.5332H26.8184V15.0144C26.3859 14.5947 25.424 14.5332 24.8377 14.5332H19.7663L18.6058 15.7916L17.5189 14.5332H9.94336V22.7552H17.3763L18.5721 21.477L19.6986 22.7552L24.2803 22.7593V20.8252H24.7308C25.3387 20.8346 26.0557 20.8101 26.6882 20.5361V22.7551H30.4673V20.6121H30.6496C30.8823 20.6121 30.9052 20.6217 30.9052 20.8547V22.7549H42.3854C43.1143 22.7549 43.8761 22.568 44.298 22.2288V22.7549H47.9395C48.6972 22.7549 49.4373 22.6485 50.0003 22.3759C50.0003 -22.6095 50.0001 33.3683 50.0001 14.5332Z"
          fill="#006FCF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.40135 12.6148L2.94276 11.3063H4.15487L4.69487 12.6148H9.41936V11.6144L9.84107 12.6191H12.2937L12.7154 11.5995V12.6148H24.4566L24.4511 10.4669H24.6783C24.8374 10.4724 24.8838 10.4871 24.8838 10.7503V12.6148H30.9565V12.1148C31.4463 12.3778 32.2081 12.6148 33.2106 12.6148H35.7654L36.3121 11.3063H37.5242L38.0589 12.6148H42.982V11.3719L43.7275 12.6148H47.6726V4.39844H43.7683V5.3688L43.2216 4.39844H39.2153V5.3688L38.7133 4.39844H33.3018C32.3959 4.39844 31.5997 4.52513 30.9565 4.8782V4.39844H27.2221V4.8782C26.8128 4.51429 26.255 4.39844 25.6349 4.39844H11.9917L11.0762 6.52058L10.1362 4.39844H5.83888V5.3688L5.36681 4.39844H1.70192L0 8.30494V12.6148H2.40135Z"
          fill="#006FCF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.7935 19.6134C26.0219 19.6134 27.2408 19.2754 27.2408 17.6385C27.2408 16.0066 25.9877 15.6973 24.8724 15.6973H20.3818L18.5943 17.6288L16.8652 15.6973H11.2129V21.5898H16.7796L18.578 19.6391L20.3084 21.5898H23.04V19.6134H24.7935ZM23.04 18.4167H24.8561C25.3961 18.4167 25.732 18.1482 25.732 17.6386C25.732 17.1233 25.3798 16.9161 24.8724 16.9161H23.04V18.4167ZM16.0681 20.3618H12.6128V19.1894H15.6981V17.9872H12.6128V16.9159H16.1362L17.6733 18.6331L16.0681 20.3618ZM21.6402 21.0539L19.4826 18.6537L21.6402 16.3297V21.0539Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.251 19.3461C33.1311 19.1745 32.8754 18.9671 32.5625 18.8514C32.9325 18.7043 33.5585 18.2244 33.5587 17.2839C33.5587 16.6117 33.2797 16.2438 32.8362 15.9753C32.3749 15.7287 31.8567 15.6973 31.1453 15.6973H27.9007V21.5898H29.3128V19.4376H30.8147C31.3274 19.4376 31.6404 19.4881 31.8457 19.6992C32.0809 19.9458 32.0768 20.3958 32.0736 20.7417C32.0733 20.7801 32.0729 20.8172 32.0729 20.8526V21.5898H33.4838V20.4217C33.4781 19.9023 33.4494 19.6338 33.251 19.3461ZM31.7138 18.1181C31.5258 18.2299 31.2933 18.2395 31.0199 18.2395H29.3126V16.9161H31.0431C31.2933 16.9161 31.5437 16.9214 31.7138 17.0225C31.8959 17.1179 32.0048 17.3004 32.0048 17.5526C32.0048 17.8047 31.8959 18.0078 31.7138 18.1181Z"
          fill="white"
        />
        <path
          d="M44.395 18.482C44.6686 18.7658 44.8153 19.124 44.8153 19.7305C44.8153 20.9981 44.0249 21.5898 42.6076 21.5898H39.8703V20.3263H42.5966C42.8631 20.3263 43.0522 20.2909 43.1706 20.1804C43.2673 20.0892 43.3366 19.9568 43.3366 19.796C43.3366 19.6244 43.2616 19.4881 43.1651 19.4064C43.0576 19.3164 42.9094 19.2756 42.6647 19.2756C42.5786 19.2726 42.4911 19.2703 42.4028 19.2678C41.1419 19.2335 39.7045 19.1943 39.7045 17.4518C39.7045 16.5971 40.2404 15.6974 41.7138 15.6974H44.5312V16.9516H41.9532C41.6976 16.9516 41.5315 16.9612 41.3901 17.058C41.2362 17.1534 41.1791 17.2951 41.1791 17.482C41.1791 17.7043 41.3098 17.8555 41.4866 17.9209C41.6349 17.9726 41.7941 17.9877 42.0335 17.9877L42.79 18.0081C43.553 18.0268 44.0766 18.159 44.395 18.482Z"
          fill="white"
        />
        <path
          d="M50.0008 16.9512H47.4395C47.1838 16.9512 47.0139 16.9608 46.8708 17.0576C46.7225 17.1531 46.6654 17.2947 46.6654 17.4816C46.6654 17.7039 46.7906 17.8551 46.9728 17.9205C47.121 17.9722 47.2803 17.9873 47.5144 17.9873L48.276 18.0077C49.0446 18.0268 49.5576 18.1591 49.8705 18.482C49.9185 18.5199 49.9504 18.5618 49.9827 18.6043L49.9915 18.6158L49.9971 18.6231L50.0008 18.6279V20.8361C49.6594 21.3363 48.9942 21.5898 48.0937 21.5898H45.3797V20.3263H48.0827C48.3509 20.3263 48.5385 20.2909 48.6515 20.1804C48.7493 20.0892 48.8176 19.9569 48.8176 19.796C48.8176 19.6244 48.7493 19.4881 48.646 19.4064C48.544 19.3165 48.3955 19.2756 48.1508 19.2756C48.0645 19.2727 47.9768 19.2703 47.8882 19.2679C46.6229 19.2335 45.185 19.1945 45.185 17.4518C45.185 16.5971 45.7266 15.6975 47.2013 15.6975H50.0006L50.0008 16.9512Z"
          fill="white"
        />
        <path
          d="M34.3379 15.6973H39.0283V16.9159H35.7375V17.9872H38.948V19.1894H35.7375V20.3618L39.0283 20.3671V21.5898H34.3379V15.6973Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.50621 8.90767L3.54432 6.55915L2.58793 8.90767H4.50621ZM25.6964 7.97255C25.5033 8.09001 25.2749 8.09391 25.0013 8.09391H23.294V6.78541H25.0245C25.2694 6.78541 25.525 6.79643 25.6909 6.89167C25.8732 6.97749 25.986 7.16016 25.986 7.41248C25.986 7.66995 25.8787 7.87713 25.6964 7.97255ZM37.8757 8.90767L36.9032 6.55915L35.936 8.90767H37.8757ZM15.1728 11.4497H13.7321L13.7268 6.83583L11.689 11.4497H10.455L8.41191 6.83174V11.4497H5.55356L5.01357 10.1357H2.08748L1.54198 11.4497H0.015625L2.53224 5.55859H4.62023L7.0104 11.1363V5.55859H9.3041L11.1433 9.55501L12.8328 5.55859H15.1726V11.4497H15.1728ZM20.9149 11.4497H16.2202V5.55859H20.9149V6.78536H17.6256V7.84724H20.8359V9.05481H17.6256V10.2313H20.9149V11.4497ZM27.5342 7.14518C27.5342 8.08445 26.9085 8.56972 26.5439 8.71543C26.8514 8.8327 27.1141 9.03989 27.2391 9.21154C27.4375 9.50455 27.4718 9.76628 27.4718 10.2924V11.4497H26.0543L26.049 10.7068C26.049 10.3523 26.0828 9.84251 25.8271 9.5591C25.6218 9.35191 25.3088 9.30696 24.8028 9.30696H23.2942V11.4497H21.889V5.55859H25.1213C25.8395 5.55859 26.3687 5.57761 26.8231 5.84076C27.2677 6.10392 27.5342 6.48809 27.5342 7.14518ZM29.7832 11.4497H28.3492V5.55859H29.7832V11.4497ZM46.419 11.4497H44.4275L41.7637 7.02809V11.4497H38.9016L38.3547 10.1357H35.4354L34.9048 11.4497H33.2603C32.5772 11.4497 31.7123 11.2983 31.2225 10.7981C30.7286 10.2979 30.4716 9.6204 30.4716 8.54911C30.4716 7.67541 30.6252 6.8767 31.2292 6.24554C31.6836 5.77538 32.3951 5.55859 33.3635 5.55859H34.7241V6.8209H33.3921C32.8792 6.8209 32.5896 6.89731 32.3106 7.16988C32.0711 7.41794 31.9067 7.88686 31.9067 8.50433C31.9067 9.13549 32.0319 9.59055 32.2931 9.88782C32.5094 10.121 32.9026 10.1917 33.2725 10.1917H33.9037L35.8844 5.55877H37.9901L40.3695 11.1309V5.55877H42.5092L44.9796 9.66162V5.55877H46.419V11.4497Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export const PaymentLogo = () => {
  return (
    <>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="fill"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.7307 7.375C3.07492 7.375 1.7207 8.72922 1.7207 10.385V17.115C1.7207 18.7708 3.07492 20.125 4.7307 20.125H16.2107C17.8665 20.125 19.2207 18.7708 19.2207 17.115V16.675H18.0707C16.6612 16.675 15.293 15.6443 15.1637 14.1217C15.0829 13.2595 15.4112 12.454 15.98 11.895C16.4916 11.3731 17.1931 11.075 17.9507 11.075H19.2207V10.385C19.2207 8.72922 17.8665 7.375 16.2107 7.375H4.7307ZM0.220703 10.385C0.220703 7.9008 2.24649 5.875 4.7307 5.875H16.2107C18.6949 5.875 20.7207 7.9008 20.7207 10.385V11.825C20.7207 12.2392 20.3849 12.575 19.9707 12.575H17.9507C17.5916 12.575 17.2759 12.7142 17.0481 12.9482L17.0346 12.9617C16.7685 13.2214 16.6199 13.5912 16.6573 13.9839L16.6582 13.9927L16.6581 13.9927C16.711 14.6277 17.3216 15.175 18.0707 15.175H19.9707C20.3849 15.175 20.7207 15.5108 20.7207 15.925V17.115C20.7207 19.5992 18.6949 21.625 16.2107 21.625H4.7307C2.24649 21.625 0.220703 19.5992 0.220703 17.115V10.385Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5707 2.82501C12.5707 2.01748 11.7637 1.4631 11.0165 1.74629L3.07612 4.74644C2.25935 5.05565 1.7207 5.83546 1.7207 6.71502V11.285C1.7207 11.6992 1.38492 12.035 0.970703 12.035C0.55649 12.035 0.220703 11.6992 0.220703 11.285V6.71502C0.220703 5.2147 1.14224 3.87439 2.54528 3.34351L10.4849 0.343665C10.4847 0.343719 10.485 0.34361 10.4849 0.343665C12.2176 -0.312767 14.0707 0.972683 14.0707 2.82501V6.62499C14.0707 7.03921 13.7349 7.37499 13.3207 7.37499C12.9065 7.37499 12.5707 7.03921 12.5707 6.62499V2.82501Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9495 12.5742C17.5905 12.5742 17.2747 12.7134 17.0469 12.9474L17.0335 12.9609C16.7674 13.2206 16.6188 13.5904 16.6562 13.9831L16.657 13.9919L16.657 13.9919C16.7099 14.6269 17.3204 15.1742 18.0695 15.1742H20.0123C20.174 15.1638 20.2795 15.0374 20.2795 14.9042V12.8442C20.2795 12.7111 20.174 12.5846 20.0123 12.5742H17.9495ZM15.9789 11.8942C16.4905 11.3724 17.1919 11.0742 17.9495 11.0742H20.0295C20.0385 11.0742 20.0474 11.0744 20.0563 11.0747C21.0093 11.1087 21.7795 11.8799 21.7795 12.8442V14.9042C21.7795 15.8685 21.0093 16.6397 20.0563 16.6737C20.0474 16.674 20.0385 16.6742 20.0295 16.6742H18.0695C16.66 16.6742 15.2919 15.6435 15.1625 14.1209C15.0818 13.2587 15.4101 12.4532 15.9789 11.8942Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.7207 10.875C4.7207 10.4608 5.05649 10.125 5.4707 10.125H12.4707C12.8849 10.125 13.2207 10.4608 13.2207 10.875C13.2207 11.2892 12.8849 11.625 12.4707 11.625H5.4707C5.05649 11.625 4.7207 11.2892 4.7207 10.875Z"
        />
      </svg>
    </>
  );
};
export const UserAdminLogo = () => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.0001 7.32993C17.9401 7.31993 17.8701 7.31993 17.8101 7.32993C16.4301 7.27993 15.3301 6.14992 15.3301 4.74992C15.3301 3.31992 16.4801 2.16992 17.9101 2.16992C19.3401 2.16992 20.4901 3.32992 20.4901 4.74992C20.4801 6.14992 19.3801 7.27993 18.0001 7.32993Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9714 14.6101C18.3414 14.8401 19.8514 14.6001 20.9114 13.8901C22.3214 12.9501 22.3214 11.4101 20.9114 10.4701C19.8414 9.76008 18.3114 9.52008 16.9414 9.76008"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.97047 7.32993C6.03047 7.31993 6.10047 7.31993 6.16047 7.32993C7.54047 7.27993 8.64047 6.14992 8.64047 4.74992C8.64047 3.31992 7.49047 2.16992 6.06047 2.16992C4.63047 2.16992 3.48047 3.32992 3.48047 4.74992C3.49047 6.14992 4.59047 7.27993 5.97047 7.32993Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.0014 14.6101C5.6314 14.8401 4.12141 14.6001 3.06141 13.8901C1.65141 12.9501 1.65141 11.4101 3.06141 10.4701C4.13141 9.76008 5.6614 9.52008 7.0314 9.76008"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9981 14.7997C11.9381 14.7897 11.8681 14.7897 11.8081 14.7997C10.4281 14.7497 9.32812 13.6197 9.32812 12.2197C9.32812 10.7897 10.4781 9.63965 11.9081 9.63965C13.3381 9.63965 14.4881 10.7997 14.4881 12.2197C14.4781 13.6197 13.3781 14.7597 11.9981 14.7997Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.08875 17.9493C7.67875 18.8893 7.67875 20.4293 9.08875 21.3693C10.6888 22.4393 13.3087 22.4393 14.9087 21.3693C16.3187 20.4293 16.3187 18.8893 14.9087 17.9493C13.3187 16.8893 10.6888 16.8893 9.08875 17.9493Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ListSquare = () => {
  return (
    <svg
      width="5"
      height="5"
      viewBox="0 0 5 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="5" height="5" rx="1" fill="#001C12" />
    </svg>
  );
};

export const ReporticonWhite = () => {
  return (
    <>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="stroke"
      >
        <path
          d="M20 8.41992V18.1699C20 21.1699 18.21 22.1699 16 22.1699H8C5.79 22.1699 4 21.1699 4 18.1699V8.41992C4 5.16992 5.79 4.41992 8 4.41992C8 5.03992 8.24997 5.59992 8.65997 6.00992C9.06997 6.41992 9.63 6.66992 10.25 6.66992H13.75C14.99 6.66992 16 5.65992 16 4.41992C18.21 4.41992 20 5.16992 20 8.41992Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 4.41992C16 5.65992 14.99 6.66992 13.75 6.66992H10.25C9.63 6.66992 9.06997 6.41992 8.65997 6.00992C8.24997 5.59992 8 5.03992 8 4.41992C8 3.17992 9.01 2.16992 10.25 2.16992H13.75C14.37 2.16992 14.93 2.41993 15.34 2.82993C15.75 3.23993 16 3.79992 16 4.41992Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 13.1699H12"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 17.1699H16"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const RegisterationIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="stroke"
      >
        <path
          d="M18 19.0304H17.24C16.44 19.0304 15.68 19.3404 15.12 19.9004L13.41 21.5904C12.63 22.3604 11.36 22.3604 10.58 21.5904L8.87 19.9004C8.31 19.3404 7.54 19.0304 6.75 19.0304H6C4.34 19.0304 3 17.7004 3 16.0604V5.14041C3 3.50041 4.34 2.17041 6 2.17041H18C19.66 2.17041 21 3.50041 21 5.14041V16.0504C21 17.6904 19.66 19.0304 18 19.0304Z"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.071 9.12021C12.031 9.12021 11.971 9.12021 11.921 9.12021C10.871 9.08021 10.041 8.23021 10.041 7.17021C10.041 6.09021 10.911 5.22021 11.991 5.22021C13.071 5.22021 13.941 6.10021 13.941 7.17021C13.951 8.23021 13.121 9.09021 12.071 9.12021Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25141 12.1301C7.92141 13.0201 7.92141 14.4701 9.25141 15.3601C10.7614 16.3701 13.2414 16.3701 14.7514 15.3601C16.0814 14.4701 16.0814 13.0201 14.7514 12.1301C13.2414 11.1301 10.7714 11.1301 9.25141 12.1301Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const ErrorIcon = () => {
  return (
    <>
      <svg
        width="30px"
        height="30px"
        viewBox="0 0 512 512"
        xmlns="http://www.w3.org/2000/svg"
        fill="#ff392b"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <g data-name="Layer 2" id="Layer_2">
            <g
              data-name="E410, Error, Media, media player, multimedia"
              id="E410_Error_Media_media_player_multimedia"
            >
              <circle
                style={{
                  strokeWidth: "20px",
                  strokeLinejoin: "round",
                  strokeLinecap: "round",
                  fill: "none",
                  stroke: "#ff392b",
                }}
                cx="256"
                cy="256"
                r="246"
              ></circle>
              <line
                style={{
                  strokeWidth: "20px",
                  strokeLinejoin: "round",
                  strokeLinecap: "round",
                  fill: "none",
                  stroke: "#ff392b",
                }}
                x1="371.47"
                x2="140.53"
                y1="140.53"
                y2="371.47"
              ></line>
              <line
                style={{
                  strokeWidth: "20px",
                  strokeLinejoin: "round",
                  strokeLinecap: "round",
                  fill: "none",
                  stroke: "#ff392b",
                }}
                x1="371.47"
                x2="140.53"
                y1="371.47"
                y2="140.53"
              ></line>
            </g>
          </g>
        </g>
      </svg>
    </>
  );
};

export const Partnericon = ({ color }: any) => {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="stroke"
      >
        <path
          d="M6.16076 17.0977H12.1608C15.1758 17.0977 15.7158 15.8902 15.8733 14.4202L16.4358 8.42016C16.6383 6.59016 16.1133 5.09766 12.9108 5.09766H5.41076C2.20826 5.09766 1.68326 6.59016 1.88576 8.42016L2.44826 14.4202C2.60576 15.8902 3.14576 17.0977 6.16076 17.0977Z"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.16016 5.09766V4.49766C6.16016 3.17016 6.16016 2.09766 8.56016 2.09766H9.76016C12.1602 2.09766 12.1602 3.17016 12.1602 4.49766V5.09766"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6602 10.3477V11.0977C10.6602 11.1052 10.6602 11.1052 10.6602 11.1127C10.6602 11.9302 10.6527 12.5977 9.16016 12.5977C7.67516 12.5977 7.66016 11.9377 7.66016 11.1202V10.3477C7.66016 9.59766 7.66016 9.59766 8.41016 9.59766H9.91016C10.6602 9.59766 10.6602 9.59766 10.6602 10.3477Z"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3977 8.84766C14.6652 10.1077 12.6852 10.8577 10.6602 11.1127"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.125 9.0498C3.8125 10.2048 5.7175 10.9023 7.66 11.1198"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Merchanticon = () => {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.6607 5.46766C13.6157 5.46016 13.5632 5.46016 13.5182 5.46766C12.4832 5.43016 11.6582 4.58266 11.6582 3.53266C11.6582 2.46016 12.5207 1.59766 13.5932 1.59766C14.6657 1.59766 15.5282 2.46766 15.5282 3.53266C15.5207 4.58266 14.6957 5.43016 13.6607 5.46766Z"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8877 10.9278C13.9152 11.1003 15.0477 10.9203 15.8427 10.3878C16.9002 9.68278 16.9002 8.52778 15.8427 7.82278C15.0402 7.29028 13.8927 7.11027 12.8652 7.29027"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.63703 5.46766C4.68203 5.46016 4.73453 5.46016 4.77953 5.46766C5.81453 5.43016 6.63953 4.58266 6.63953 3.53266C6.63953 2.46016 5.77703 1.59766 4.70453 1.59766C3.63203 1.59766 2.76953 2.46766 2.76953 3.53266C2.77703 4.58266 3.60203 5.43016 4.63703 5.46766Z"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.41023 10.9278C4.38273 11.1003 3.25023 10.9203 2.45523 10.3878C1.39773 9.68278 1.39773 8.52778 2.45523 7.82278C3.25773 7.29028 4.40523 7.11027 5.43273 7.29027"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.15875 11.0702C9.11375 11.0627 9.06125 11.0627 9.01625 11.0702C7.98125 11.0327 7.15625 10.1852 7.15625 9.1352C7.15625 8.0627 8.01875 7.2002 9.09125 7.2002C10.1637 7.2002 11.0262 8.0702 11.0262 9.1352C11.0187 10.1852 10.1937 11.0402 9.15875 11.0702Z"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.97672 13.4322C5.91922 14.1372 5.91922 15.2922 6.97672 15.9972C8.17672 16.7997 10.1417 16.7997 11.3417 15.9972C12.3992 15.2922 12.3992 14.1372 11.3417 13.4322C10.1492 12.6372 8.17672 12.6372 6.97672 13.4322Z"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Transactionicon = () => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.8439 11.9102C16.8439 14.6514 14.7575 16.8685 12.1777 16.8685L12.8777 15.6289"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.17773 6.24349C2.17773 3.50224 4.26419 1.28516 6.84392 1.28516L6.144 2.52474"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8347 7.01807C15.6893 9.42855 13.7356 11.2546 11.4671 11.1001L11.1412 11.0779C11.1173 8.92563 9.61063 7.10531 7.60477 6.80548L7.62566 6.45912C7.77102 4.04864 9.72472 2.22267 11.9932 2.37713C14.2616 2.53159 15.98 4.6076 15.8347 7.01807Z"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="5.1482"
          cy="12.4343"
          r="3.73961"
          fill="white"
          stroke="#001C12"
          strokeWidth="1.2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.65028 10.6557C4.41147 10.6557 4.19499 10.876 4.19499 11.1761C4.19499 11.3805 4.23639 11.4739 4.27304 11.5236C4.31227 11.5768 4.37824 11.624 4.50812 11.6731L6.05079 12.2425C6.22263 12.3072 6.40898 12.4042 6.54662 12.5908C6.68692 12.781 6.74691 13.0229 6.74691 13.3146C6.74691 13.9252 6.29767 14.4448 5.71772 14.4448H4.75741C4.11534 14.4448 3.62109 13.8713 3.62109 13.1926C3.62109 13.0242 3.74956 12.8877 3.90804 12.8877C4.06652 12.8877 4.19499 13.0242 4.19499 13.1926C4.19499 13.5628 4.45828 13.8349 4.75741 13.8349H5.71772C5.95653 13.8349 6.17301 13.6146 6.17301 13.3146C6.17301 13.1102 6.13161 13.0167 6.09496 12.967C6.05573 12.9139 5.98976 12.8666 5.85989 12.8176L4.31721 12.2482C4.14537 12.1834 3.95902 12.0864 3.82138 11.8999C3.68108 11.7097 3.62109 11.4677 3.62109 11.1761C3.62109 10.5655 4.07033 10.0459 4.65028 10.0459H5.6106C6.25266 10.0459 6.74691 10.6194 6.74691 11.2981C6.74691 11.4665 6.61844 11.603 6.45996 11.603C6.30148 11.603 6.17301 11.4665 6.17301 11.2981C6.17301 10.9279 5.90972 10.6557 5.6106 10.6557H4.65028Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.18148 9.50098C5.33996 9.50098 5.46843 9.63749 5.46843 9.80589V14.6845C5.46843 14.8529 5.33996 14.9894 5.18148 14.9894C5.023 14.9894 4.89453 14.8529 4.89453 14.6845V9.80589C4.89453 9.63749 5.023 9.50098 5.18148 9.50098Z"
          fill="#001C12"
        />
      </svg>
    </>
  );
};

export const Terminalicon = () => {
  return (
    <>
      <svg
        width="15"
        height="19"
        viewBox="0 0 15 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.636 5.34766V13.8477C13.636 17.2477 12.8265 18.0977 9.58836 18.0977H4.73121C1.49312 18.0977 0.683594 17.2477 0.683594 13.8477V5.34766C0.683594 1.94766 1.49312 1.09766 4.73121 1.09766H9.58836C12.8265 1.09766 13.636 1.94766 13.636 5.34766Z"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.91491 4.88184H5.29883"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.10631 14.8235C7.88019 14.8235 8.50754 14.2336 8.50754 13.506C8.50754 12.7783 7.88019 12.1885 7.10631 12.1885C6.33243 12.1885 5.70508 12.7783 5.70508 13.506C5.70508 14.2336 6.33243 14.8235 7.10631 14.8235Z"
          stroke="#001C12"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Reconcilationicon = () => {
  return (
    <>
      <svg
        width="17"
        height="19"
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.13299 1.64113C1.88372 0.794435 3.06406 0.597656 4.56492 0.597656H10.5636C12.0644 0.597656 13.2448 0.794435 13.9955 1.64113C14.733 2.47293 14.9039 3.76771 14.9039 5.44511V9.0116C14.9039 9.35838 14.6374 9.63951 14.3088 9.63951C13.9801 9.63951 13.7137 9.35838 13.7137 9.0116V5.44511C13.7137 3.74855 13.5116 2.93355 13.1264 2.49907C12.7543 2.07949 12.0621 1.85347 10.5636 1.85347H4.56492C3.06644 1.85347 2.37418 2.07949 2.00214 2.49907C1.6169 2.93355 1.41482 3.74855 1.41482 5.44511V14.8721C1.41482 15.3782 1.48154 15.7415 1.57372 15.98C1.6651 16.2164 1.76248 16.2873 1.80992 16.3089C1.85301 16.3285 1.95396 16.3528 2.1538 16.2617C2.35947 16.168 2.63013 15.9669 2.94721 15.6078C2.95179 15.6026 2.95646 15.5975 2.9612 15.5925L2.96367 15.5899C3.8661 14.5872 5.28841 14.6693 6.07311 15.7771L6.87435 16.9071C7.07124 17.1848 7.01751 17.5783 6.75434 17.786C6.49117 17.9937 6.11822 17.9371 5.92133 17.6594L5.11992 16.5291L5.11974 16.5289C4.7795 16.0485 4.22282 16.0112 3.82363 16.4581L3.81201 16.4707L3.81103 16.4718C3.42805 16.904 3.02964 17.2306 2.62558 17.4147C2.21319 17.6025 1.76119 17.6541 1.3391 17.4622C0.921365 17.2724 0.641351 16.8933 0.47163 16.4542C0.302703 16.0172 0.224609 15.4794 0.224609 14.8721V5.44511C0.224609 3.76771 0.39546 2.47293 1.13299 1.64113Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4838 12.7373C11.4102 12.7373 10.5398 13.6556 10.5398 14.7884C10.5398 15.9213 11.4102 16.8396 12.4838 16.8396C13.5575 16.8396 14.4278 15.9213 14.4278 14.7884C14.4278 13.6556 13.5575 12.7373 12.4838 12.7373ZM9.34961 14.7884C9.34961 12.962 10.7529 11.4814 12.4838 11.4814C14.2148 11.4814 15.6181 12.962 15.6181 14.7884C15.6181 16.6148 14.2148 18.0954 12.4838 18.0954C10.7529 18.0954 9.34961 16.6148 9.34961 14.7884Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2856 16.6888C14.518 16.4436 14.8948 16.4436 15.1272 16.6888L15.9207 17.526C16.1531 17.7712 16.1531 18.1688 15.9207 18.414C15.6883 18.6592 15.3115 18.6592 15.0791 18.414L14.2856 17.5768C14.0532 17.3316 14.0532 16.934 14.2856 16.6888Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.79492 5.41209C3.79492 5.0653 4.06136 4.78418 4.39003 4.78418H10.7378C11.0665 4.78418 11.3329 5.0653 11.3329 5.41209C11.3329 5.75887 11.0665 6.03999 10.7378 6.03999H4.39003C4.06136 6.03999 3.79492 5.75887 3.79492 5.41209Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.58789 8.76072C4.58789 8.41394 4.85433 8.13281 5.183 8.13281H9.94384C10.2725 8.13281 10.5389 8.41394 10.5389 8.76072C10.5389 9.1075 10.2725 9.38863 9.94384 9.38863H5.183C4.85433 9.38863 4.58789 9.1075 4.58789 8.76072Z"
          fill="#001C12"
        />
      </svg>
    </>
  );
};

export const SettlementIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
      <path
        d="M9.30727 5.86155C8.87796 6.16762 8.35258 6.34766 7.78516 6.34766C6.33541 6.34766 5.16016 5.1724 5.16016 3.72266C5.16016 2.27291 6.33541 1.09766 7.78516 1.09766C8.7249 1.09766 9.5493 1.59147 10.013 2.33376M3.66016 14.663H5.61787C5.87313 14.663 6.12682 14.6934 6.37427 14.7541L8.44283 15.2568C8.89166 15.3662 9.35924 15.3768 9.81276 15.2887L12.0999 14.8437C12.7041 14.726 13.2598 14.4367 13.6954 14.013L15.3136 12.4389C15.7757 11.9902 15.7757 11.262 15.3136 10.8125C14.8975 10.4077 14.2387 10.3622 13.768 10.7054L11.8821 12.0813C11.612 12.2787 11.2834 12.385 10.9454 12.385H9.12428L10.2835 12.385C10.9368 12.385 11.466 11.8702 11.466 11.2346V11.0045C11.466 10.4768 11.0968 10.0166 10.5707 9.88906L8.7816 9.45396C8.49044 9.38334 8.19226 9.34766 7.89251 9.34766C7.1689 9.34766 5.85908 9.94677 5.85908 9.94677L3.66016 10.8663M14.1602 4.47266C14.1602 5.9224 12.9849 7.09766 11.5352 7.09766C10.0854 7.09766 8.91016 5.9224 8.91016 4.47266C8.91016 3.02291 10.0854 1.84766 11.5352 1.84766C12.9849 1.84766 14.1602 3.02291 14.1602 4.47266ZM0.660156 10.5477L0.660156 14.8977C0.660156 15.3177 0.660156 15.5277 0.741901 15.6881C0.813806 15.8293 0.928542 15.944 1.06966 16.0159C1.2301 16.0977 1.44012 16.0977 1.86016 16.0977H2.46016C2.8802 16.0977 3.09022 16.0977 3.25065 16.0159C3.39177 15.944 3.50651 15.8293 3.57841 15.6881C3.66016 15.5277 3.66016 15.3177 3.66016 14.8977V10.5477C3.66016 10.1276 3.66016 9.9176 3.57841 9.75716C3.50651 9.61604 3.39177 9.50131 3.25065 9.4294C3.09022 9.34766 2.8802 9.34766 2.46016 9.34766L1.86016 9.34766C1.44012 9.34766 1.2301 9.34766 1.06966 9.4294C0.928542 9.50131 0.813806 9.61604 0.741901 9.75716C0.660156 9.9176 0.660156 10.1276 0.660156 10.5477Z"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Invoicingicon = () => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7921 1.25242C13.2539 1.25376 12.8169 1.69131 12.8169 2.22242V7.02622H14.8723C15.3569 7.02622 15.6963 6.87536 15.9133 6.65836C16.1303 6.44137 16.2812 6.10197 16.2812 5.61741V3.7544C16.2812 3.06898 16.0015 2.44298 15.5482 1.98263C15.1001 1.53527 14.476 1.25944 13.7921 1.25242ZM11.6621 2.22242C11.6621 1.04529 12.6249 0.0976562 13.7946 0.0976562H13.7999L13.7999 0.0976806C14.7924 0.106786 15.7063 0.507703 16.3661 1.16748L16.3689 1.1703L16.3689 1.17031C17.0233 1.83379 17.4359 2.74688 17.4359 3.7544V5.61741C17.4359 6.3492 17.2018 7.0029 16.7298 7.47491C16.2578 7.94692 15.6041 8.18098 14.8723 8.18098H12.2395C11.9206 8.18098 11.6621 7.92248 11.6621 7.6036V2.22242Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.69876 1.19934C2.31832 0.481898 3.26855 0.0976562 4.54151 0.0976562H13.7796C14.0985 0.0976562 14.357 0.356158 14.357 0.675037C14.357 0.993915 14.0985 1.25242 13.7796 1.25242C13.2516 1.25242 12.8173 1.68677 12.8173 2.21472V15.302C12.8173 16.4119 11.5497 17.039 10.664 16.3815L10.6622 16.3801L9.33968 15.3902C9.2733 15.3391 9.16718 15.3421 9.09923 15.41L7.8059 16.7034C7.28018 17.2291 6.42187 17.2291 5.89616 16.7034L5.89493 16.7021L4.61824 15.4177C4.61812 15.4176 4.61836 15.4179 4.61824 15.4177C4.54185 15.3417 4.43194 15.338 4.35674 15.3944L3.04253 16.3781C3.04201 16.3785 3.04149 16.3789 3.04098 16.3793C2.14936 17.0529 0.884766 16.4132 0.884766 15.302V3.7544C0.884766 2.82838 1.09288 1.90096 1.69876 1.19934ZM11.8948 1.25242H4.54151C3.50495 1.25242 2.91549 1.55718 2.57275 1.95408C2.21633 2.36681 2.03953 2.97907 2.03953 3.7544V15.302C2.03953 15.4681 2.22073 15.552 2.34522 15.4577L2.34788 15.4556L3.66389 14.4706C4.20444 14.0652 4.9569 14.1233 5.43478 14.6012L5.43601 14.6024L6.71269 15.8868C6.71258 15.8867 6.71281 15.8869 6.71269 15.8868C6.7875 15.9612 6.91472 15.9615 6.98936 15.8868L8.28269 14.5935C8.7526 14.1236 9.50641 14.0642 10.0403 14.4722L11.3524 15.4543C11.3526 15.4544 11.3528 15.4546 11.353 15.4548C11.4834 15.5508 11.6625 15.4544 11.6625 15.302V2.21472C11.6625 1.86863 11.7464 1.54143 11.8948 1.25242Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.96484 6.06371C3.96484 5.74483 4.22335 5.48633 4.54222 5.48633H9.16127C9.48014 5.48633 9.73865 5.74483 9.73865 6.06371C9.73865 6.38259 9.48014 6.64109 9.16127 6.64109H4.54222C4.22335 6.64109 3.96484 6.38259 3.96484 6.06371Z"
          fill="#001C12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.54102 9.14379C4.54102 8.82491 4.79952 8.56641 5.1184 8.56641H8.58268C8.90156 8.56641 9.16006 8.82491 9.16006 9.14379C9.16006 9.46266 8.90156 9.72117 8.58268 9.72117H5.1184C4.79952 9.72117 4.54102 9.46266 4.54102 9.14379Z"
          fill="#001C12"
        />
      </svg>
    </>
  );
};

export const ToDoIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3701 8.88086H17.6201"
          stroke="#001C12"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.37988 8.88086L7.12988 9.63086L9.37988 7.38086"
          stroke="#001C12"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3701 15.8809H17.6201"
          stroke="#001C12"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.37988 15.8809L7.12988 16.6309L9.37988 14.3809"
          stroke="#001C12"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
          stroke="#001C12"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const LayoutIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 2V22"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 12H22"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const QuestionLogo = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.1"
          d="M8.00021 0C3.58176 0 0 3.58176 0 8.00021C5.46967e-05 9.05081 0.20704 10.0911 0.609139 11.0617C1.01124 12.0323 1.60057 12.9142 2.3435 13.6571C3.08643 14.3999 3.96839 14.9892 4.93905 15.3912C5.9097 15.7932 6.95002 16.0001 8.00062 16C9.05123 15.9999 10.0915 15.793 11.0621 15.3909C12.0327 14.9888 12.9147 14.3994 13.6575 13.6565C14.4004 12.9136 14.9896 12.0316 15.3916 11.061C15.7936 10.0903 16.0005 9.04998 16.0004 7.99937C16.0004 3.58176 12.4178 0 8.00021 0ZM7.87437 12.6662H7.83187C7.18019 12.647 6.72017 12.1662 6.73934 11.5236C6.75768 10.8919 7.22852 10.4328 7.85854 10.4328L7.89687 10.4344C8.56689 10.4536 9.0219 10.9295 9.00273 11.5903C8.98357 12.2237 8.52105 12.6662 7.87437 12.6662ZM10.6169 7.22352C10.4636 7.44019 10.1269 7.71187 9.70192 8.04271L9.23357 8.36522C8.9769 8.56522 8.8219 8.7544 8.76439 8.93857C8.71773 9.08357 8.69606 9.12274 8.69189 9.41858V9.49358H6.90435L6.90935 9.34191C6.93185 8.72189 6.94685 8.35522 7.20435 8.05271C7.60853 7.57936 8.50022 7.00435 8.53772 6.98018C8.66005 6.89081 8.76677 6.78184 8.85356 6.65767C9.04107 6.3985 9.12357 6.19516 9.12357 5.99682C9.12357 5.71848 9.0419 5.46098 8.8794 5.23347C8.72273 5.0118 8.42522 4.90179 7.99521 4.90179C7.56853 4.90179 7.27602 5.0368 7.10185 5.31514C6.92185 5.59931 6.83101 5.89849 6.83101 6.20433V6.281H4.98846L4.9918 6.20099C5.0393 5.07347 5.44264 4.26094 6.18766 3.78676C6.65684 3.48592 7.24102 3.33342 7.92187 3.33342C8.8119 3.33342 9.56525 3.55009 10.1569 3.97677C10.7578 4.40928 11.062 5.05763 11.062 5.90265C11.0611 6.37517 10.912 6.81934 10.6169 7.22352Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export const ContextMenuLogo = ({ color }: any) => {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.02979 16.3546C9.02979 17.2446 9.75789 17.9727 10.6478 17.9727C11.5377 17.9727 12.2658 17.2446 12.2658 16.3546C12.2658 15.4647 11.5377 14.7366 10.6478 14.7366C9.75789 14.7366 9.02979 15.4647 9.02979 16.3546Z"
          fill={color}
          /* fill="#8B97A3"
           */
        />
        <path
          d="M9.02979 5.02652C9.02979 5.91643 9.75789 6.64453 10.6478 6.64453C11.5377 6.64453 12.2658 5.91643 12.2658 5.02652C12.2658 4.13662 11.5377 3.40852 10.6478 3.40852C9.75789 3.40852 9.02979 4.13662 9.02979 5.02652Z"
          fill={color}
          /* fill="#8B97A3"
           */
        />
        <path
          d="M9.02979 10.6906C9.02979 11.5805 9.75789 12.3086 10.6478 12.3086C11.5377 12.3086 12.2658 11.5805 12.2658 10.6906C12.2658 9.80068 11.5377 9.07258 10.6478 9.07258C9.75789 9.07258 9.02979 9.80068 9.02979 10.6906Z"
          fill={color}
          /* fill="#8B97A3"
           */
        />
      </svg>
    </>
  );
};

export const ProductIcon = ({ color }: any) => {
  return (
    <>
      <svg
        stroke={color}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.6875 7.51955V6.58997C7.6875 4.43372 9.42208 2.3158 11.5783 2.11455C14.1467 1.86539 16.3125 3.88747 16.3125 6.40789V7.73039"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.12447 21.2526H14.8745C18.727 21.2526 19.417 19.7097 19.6182 17.8314L20.337 12.0814C20.5957 9.74302 19.9249 7.83594 15.8328 7.83594H8.16613C4.07405 7.83594 3.40322 9.74302 3.66197 12.0814L4.38072 17.8314C4.58197 19.7097 5.27197 21.2526 9.12447 21.2526Z"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.3499 11.6706H15.3585"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.6409 11.6706H8.6495"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const SignOutLogo = () => {
  return (
    <>
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.76367 12.1122V13.458C5.76367 15.2069 7.18144 16.6247 8.93034 16.6247H12.3741C14.123 16.6247 15.5408 15.2069 15.5408 13.458V4.74967C15.5408 3.00077 14.123 1.58301 12.3741 1.58301H8.93034C7.18144 1.58301 5.76367 3.00077 5.76367 4.74968V6.09551"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M3.5082 11.3604L1.81175 9.66389C1.50258 9.35473 1.50258 8.85347 1.81175 8.54431L3.5082 6.84785"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M2.00039 9.10351L11.0254 9.10352"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};

export const CurrencyIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99819 6.32417C7.47562 6.32417 7.00191 6.77785 7.00191 7.3958C7.00191 7.81665 7.09251 8.00914 7.17271 8.11144C7.25855 8.22095 7.40291 8.31823 7.68711 8.41916L11.0628 9.59186C11.4389 9.72514 11.8466 9.9249 12.1478 10.3091C12.4548 10.7008 12.5861 11.199 12.5861 11.7995C12.5861 13.0569 11.6031 14.127 10.334 14.127H8.23261C6.82762 14.127 5.74609 12.946 5.74609 11.5484C5.74609 11.2016 6.02722 10.9205 6.374 10.9205C6.72078 10.9205 7.00191 11.2016 7.00191 11.5484C7.00191 12.3107 7.57805 12.8711 8.23261 12.8711H10.334C10.8566 12.8711 11.3303 12.4175 11.3303 11.7995C11.3303 11.3787 11.2397 11.1862 11.1595 11.0839C11.0736 10.9744 10.9293 10.8771 10.6451 10.7762L7.26935 9.60346C6.89333 9.47019 6.48555 9.27042 6.18436 8.8862C5.87735 8.49456 5.74609 7.99635 5.74609 7.3958C5.74609 6.13841 6.72913 5.06836 7.99819 5.06836H10.0996C11.5046 5.06836 12.5861 6.24931 12.5861 7.64696C12.5861 7.99375 12.305 8.27487 11.9582 8.27487C11.6114 8.27487 11.3303 7.99375 11.3303 7.64696C11.3303 6.88462 10.7541 6.32417 10.0996 6.32417H7.99819Z"
        fill="#3A3A3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16111 3.94727C9.50789 3.94727 9.78902 4.22839 9.78902 4.57517V14.6217C9.78902 14.9685 9.50789 15.2496 9.16111 15.2496C8.81433 15.2496 8.5332 14.9685 8.5332 14.6217V4.57517C8.5332 4.22839 8.81433 3.94727 9.16111 3.94727Z"
        fill="#3A3A3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16016 1.85347C4.88316 1.85347 1.41597 5.32066 1.41597 9.59766C1.41597 13.8747 4.88316 17.3418 9.16016 17.3418C13.4372 17.3418 16.9043 13.8747 16.9043 9.59766C16.9043 5.32066 13.4372 1.85347 9.16016 1.85347ZM0.160156 9.59766C0.160156 4.62709 4.18959 0.597656 9.16016 0.597656C14.1307 0.597656 18.1602 4.62709 18.1602 9.59766C18.1602 14.5682 14.1307 18.5977 9.16016 18.5977C4.18959 18.5977 0.160156 14.5682 0.160156 9.59766Z"
        fill="#3A3A3A"
      />
    </svg>
  );
};

export const BSCategoryIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6602 6.80016V3.77016C16.6602 2.57766 16.1802 2.09766 14.9877 2.09766H11.9577C10.7652 2.09766 10.2852 2.57766 10.2852 3.77016V6.80016C10.2852 7.99266 10.7652 8.47266 11.9577 8.47266H14.9877C16.1802 8.47266 16.6602 7.99266 16.6602 6.80016Z"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.03516 6.98766V3.58266C8.03516 2.52516 7.55516 2.09766 6.36266 2.09766H3.33266C2.14016 2.09766 1.66016 2.52516 1.66016 3.58266V6.98016C1.66016 8.04516 2.14016 8.46516 3.33266 8.46516H6.36266C7.55516 8.47266 8.03516 8.04516 8.03516 6.98766Z"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.03516 15.4252V12.3952C8.03516 11.2027 7.55516 10.7227 6.36266 10.7227H3.33266C2.14016 10.7227 1.66016 11.2027 1.66016 12.3952V15.4252C1.66016 16.6177 2.14016 17.0977 3.33266 17.0977H6.36266C7.55516 17.0977 8.03516 16.6177 8.03516 15.4252Z"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8102 15.6477C15.1356 15.6477 16.2102 14.5731 16.2102 13.2477C16.2102 11.9222 15.1356 10.8477 13.8102 10.8477C12.4847 10.8477 11.4102 11.9222 11.4102 13.2477C11.4102 14.5731 12.4847 15.6477 13.8102 15.6477Z"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6602 16.0977L15.9102 15.3477"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CountryIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6602 9.59766C16.6602 5.45766 13.3002 2.09766 9.16016 2.09766C5.02016 2.09766 1.66016 5.45766 1.66016 9.59766C1.66016 13.7377 5.02016 17.0977 9.16016 17.0977"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.15938 2.84766H6.90938C5.44688 7.22766 5.44688 11.9677 6.90938 16.3477H6.15938"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4102 2.84766C12.1377 5.03766 12.5052 7.31766 12.5052 9.59766"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.41016 12.5977V11.8477C4.60016 12.5752 6.88016 12.9427 9.16016 12.9427"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.41016 7.34688C6.79016 5.88438 11.5302 5.88438 15.9102 7.34688"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8102 16.6477C15.1356 16.6477 16.2102 15.5731 16.2102 14.2477C16.2102 12.9222 15.1356 11.8477 13.8102 11.8477C12.4847 11.8477 11.4102 12.9222 11.4102 14.2477C11.4102 15.5731 12.4847 16.6477 13.8102 16.6477Z"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6602 17.0977L15.9102 16.3477"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CityIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66016 17.0977H16.6602"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.37109 17.0986L2.40859 8.07606C2.40859 7.61856 2.62609 7.1836 2.98609 6.8986L8.23609 2.81109C8.77609 2.39109 9.53359 2.39109 10.0811 2.81109L15.3311 6.8911C15.6986 7.1761 15.9086 7.61106 15.9086 8.07606V17.0986"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M9.91016 13.3477H8.41016C7.78766 13.3477 7.28516 13.8502 7.28516 14.4727V17.0977H11.0352V14.4727C11.0352 13.8502 10.5327 13.3477 9.91016 13.3477Z"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M7.28516 10.9102H5.78516C5.37266 10.9102 5.03516 10.5727 5.03516 10.1602V9.03516C5.03516 8.62266 5.37266 8.28516 5.78516 8.28516H7.28516C7.69766 8.28516 8.03516 8.62266 8.03516 9.03516V10.1602C8.03516 10.5727 7.69766 10.9102 7.28516 10.9102Z"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M12.5352 10.9102H11.0352C10.6227 10.9102 10.2852 10.5727 10.2852 10.1602V9.03516C10.2852 8.62266 10.6227 8.28516 11.0352 8.28516H12.5352C12.9477 8.28516 13.2852 8.62266 13.2852 9.03516V10.1602C13.2852 10.5727 12.9477 10.9102 12.5352 10.9102Z"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M14.4104 5.84766L14.3879 3.59766H11.0879"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TMSIcon = () => {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0253906 4.95038C0.0253906 4.63692 0.279499 4.38281 0.592958 4.38281H9.29566C9.60912 4.38281 9.86323 4.63692 9.86323 4.95038C9.86323 5.26384 9.60912 5.51795 9.29566 5.51795H0.592958C0.279499 5.51795 0.0253906 5.26384 0.0253906 4.95038Z"
        fill="#3A3A3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.05273 11.0031C3.05273 10.6897 3.30684 10.4355 3.6203 10.4355H5.13382C5.44727 10.4355 5.70138 10.6897 5.70138 11.0031C5.70138 11.3166 5.44727 11.5707 5.13382 11.5707H3.6203C3.30684 11.5707 3.05273 11.3166 3.05273 11.0031Z"
        fill="#3A3A3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.45898 11.0031C6.45898 10.6897 6.71309 10.4355 7.02655 10.4355H10.0536C10.367 10.4355 10.6211 10.6897 10.6211 11.0031C10.6211 11.3166 10.367 11.5707 10.0536 11.5707H7.02655C6.71309 11.5707 6.45898 11.3166 6.45898 11.0031Z"
        fill="#3A3A3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66458 2.23382C1.34291 2.55187 1.16053 3.15638 1.16053 4.48739V10.7079C1.16053 12.0389 1.34291 12.6434 1.66458 12.9615C1.98848 13.2818 2.60518 13.4625 3.95296 13.4625H12.3681C13.7159 13.4625 14.3326 13.2818 14.6565 12.9615C14.9781 12.6434 15.1605 12.0389 15.1605 10.7079V6.8636C15.1605 6.55014 15.4146 6.29603 15.7281 6.29603C16.0416 6.29603 16.2957 6.55014 16.2957 6.8636V10.7079C16.2957 12.0331 16.1413 13.0897 15.4546 13.7687C14.7701 14.4455 13.7068 14.5977 12.3681 14.5977H3.95296C2.61425 14.5977 1.55095 14.4455 0.866473 13.7687C0.179764 13.0897 0.0253906 12.0331 0.0253906 10.7079V4.48739C0.0253906 3.16217 0.179764 2.10561 0.866473 1.42663C1.55095 0.749859 2.61425 0.597656 3.95296 0.597656H9.29566C9.60912 0.597656 9.86323 0.851765 9.86323 1.16522C9.86323 1.47868 9.60912 1.73279 9.29566 1.73279H3.95296C2.60518 1.73279 1.98848 1.91356 1.66458 2.23382Z"
        fill="#3A3A3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1291 0.763893C16.3508 0.985542 16.3508 1.34491 16.1291 1.56655L13.1021 4.59358C12.8804 4.81523 12.5211 4.81523 12.2994 4.59358L11.1643 3.45845C10.9426 3.2368 10.9426 2.87743 11.1643 2.65578C11.3859 2.43414 11.7453 2.43414 11.9669 2.65578L12.7007 3.38959L15.3264 0.763893C15.5481 0.542244 15.9075 0.542244 16.1291 0.763893Z"
        fill="#3A3A3A"
      />
    </svg>
  );
};

export const RetailerIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="stroke"
    >
      <path
        d="M4.58485 13.3477H13.7273C15.1523 13.3477 15.9023 12.5977 15.9023 11.1727V2.09766H2.40234V11.1727C2.40984 12.5977 3.15985 13.3477 4.58485 13.3477Z"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66016 2.09766H16.6602"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.16016 17.0977L9.16016 15.5977V13.3477"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1602 17.0977L9.16016 15.5977"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.78516 8.84766L8.14765 6.87515C8.33515 6.71765 8.58265 6.76266 8.71015 6.97266L9.61016 8.47266C9.73766 8.68266 9.98516 8.72016 10.1727 8.57016L12.5352 6.59766"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SettingsIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="stroke"
    >
      <path
        d="M12 15.625C13.6569 15.625 15 14.2819 15 12.625C15 10.9681 13.6569 9.625 12 9.625C10.3431 9.625 9 10.9681 9 12.625C9 14.2819 10.3431 15.625 12 15.625Z"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 13.5044V11.7444C2 10.7044 2.85 9.84445 3.9 9.84445C5.71 9.84445 6.45 8.56445 5.54 6.99445C5.02 6.09445 5.33 4.92445 6.24 4.40445L7.97 3.41445C8.76 2.94445 9.78 3.22445 10.25 4.01445L10.36 4.20445C11.26 5.77445 12.74 5.77445 13.65 4.20445L13.76 4.01445C14.23 3.22445 15.25 2.94445 16.04 3.41445L17.77 4.40445C18.68 4.92445 18.99 6.09445 18.47 6.99445C17.56 8.56445 18.3 9.84445 20.11 9.84445C21.15 9.84445 22.01 10.6944 22.01 11.7444V13.5044C22.01 14.5444 21.16 15.4044 20.11 15.4044C18.3 15.4044 17.56 16.6844 18.47 18.2544C18.99 19.1644 18.68 20.3244 17.77 20.8444L16.04 21.8344C15.25 22.3044 14.23 22.0244 13.76 21.2344L13.65 21.0444C12.75 19.4744 11.27 19.4744 10.36 21.0444L10.25 21.2344C9.78 22.0244 8.76 22.3044 7.97 21.8344L6.24 20.8444C5.33 20.3244 5.02 19.1544 5.54 18.2544C6.45 16.6844 5.71 15.4044 3.9 15.4044C2.85 15.4044 2 14.5444 2 13.5044Z"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddUserLogo = () => {
  return (
    <>
      <svg
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.5 18.543H14.5"
          stroke="#001C12"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 20.4135V16.6724"
          stroke="#001C12"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1586 10.4712C12.0586 10.4619 11.9386 10.4619 11.8286 10.4712C9.44863 10.3964 7.55863 8.57262 7.55863 6.32794C7.54863 4.0365 9.53863 2.17529 11.9886 2.17529C14.4386 2.17529 16.4286 4.0365 16.4286 6.32794C16.4286 8.57262 14.5286 10.3964 12.1586 10.4712Z"
          stroke="#001C12"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9891 20.7033C10.1691 20.7033 8.35906 20.2731 6.97906 19.4126C4.55906 17.8975 4.55906 15.4283 6.97906 13.9225C9.72906 12.2016 14.2391 12.2016 16.9891 13.9225"
          stroke="#001C12"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const AddNewTerminalIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.58485 13.3477H13.7273C15.1523 13.3477 15.9023 12.5977 15.9023 11.1727V2.09766H2.40234V11.1727C2.40984 12.5977 3.15985 13.3477 4.58485 13.3477Z"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66016 2.09766H16.6602"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.16016 17.0977L9.16016 15.5977V13.3477"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1602 17.0977L9.16016 15.5977"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.78516 8.84766L8.14765 6.87515C8.33515 6.71765 8.58265 6.76266 8.71015 6.97266L9.61016 8.47266C9.73766 8.68266 9.98516 8.72016 10.1727 8.57016L12.5352 6.59766"
        stroke="#3A3A3A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReconcilationPlusIcon = () => {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.53851 1.80253C2.36532 0.870038 3.66526 0.65332 5.31819 0.65332H11.9247C13.5776 0.65332 14.8776 0.870038 15.7044 1.80253C16.5166 2.71862 16.7048 4.14459 16.7048 5.99196V9.91985C16.7048 10.3018 16.4114 10.6114 16.0494 10.6114C15.6874 10.6114 15.394 10.3018 15.394 9.91985V5.99196C15.394 4.12349 15.1714 3.22591 14.7472 2.74741C14.3374 2.2853 13.575 2.03639 11.9247 2.03639H5.31819C3.66788 2.03639 2.90547 2.2853 2.49574 2.74741C2.07146 3.22591 1.8489 4.12349 1.8489 5.99196V16.3741C1.8489 16.9316 1.92238 17.3317 2.0239 17.5943C2.12454 17.8547 2.23179 17.9328 2.28404 17.9565C2.3315 17.9781 2.44267 18.0049 2.66276 17.9046C2.88927 17.8015 3.18736 17.58 3.53657 17.1844C3.54161 17.1787 3.54675 17.1731 3.55198 17.1676L3.55469 17.1647C4.54857 16.0605 6.115 16.1508 6.97921 17.3709L7.86164 18.6154C8.07848 18.9212 8.01931 19.3546 7.72947 19.5834C7.43964 19.8121 7.0289 19.7497 6.81206 19.4439L5.92943 18.1991L5.92924 18.1989C5.55452 17.6698 4.94143 17.6287 4.50179 18.1209L4.489 18.1348L4.48792 18.136C4.06613 18.612 3.62735 18.9717 3.18234 19.1744C2.72817 19.3813 2.23036 19.438 1.76551 19.2268C1.30544 19.0177 0.997056 18.6002 0.810137 18.1166C0.624092 17.6353 0.538086 17.043 0.538086 16.3741V5.99196C0.538086 4.14459 0.726249 2.71862 1.53851 1.80253Z"
        fill="#001C12"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0396 14.0227C12.8572 14.0227 11.8986 15.0341 11.8986 16.2817C11.8986 17.5293 12.8571 18.5407 14.0396 18.5407C15.222 18.5407 16.1806 17.5293 16.1806 16.2817C16.1806 15.0341 15.222 14.0227 14.0396 14.0227ZM10.5878 16.2817C10.5878 14.2703 12.1332 12.6396 14.0396 12.6396C15.946 12.6396 17.4914 14.2703 17.4914 16.2817C17.4914 18.2932 15.946 19.9238 14.0396 19.9238C12.1332 19.9238 10.5878 18.2932 10.5878 16.2817Z"
        fill="#001C12"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0229 18.3744C16.2788 18.1044 16.6938 18.1044 16.9498 18.3744L17.8237 19.2965C18.0796 19.5665 18.0796 20.0044 17.8237 20.2744C17.5677 20.5445 17.1527 20.5445 16.8968 20.2744L16.0229 19.3524C15.7669 19.0823 15.7669 18.6445 16.0229 18.3744Z"
        fill="#001C12"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.4707 5.9552C4.4707 5.57328 4.76414 5.26367 5.12611 5.26367H12.1171C12.4791 5.26367 12.7725 5.57328 12.7725 5.9552C12.7725 6.33713 12.4791 6.64674 12.1171 6.64674H5.12611C4.76414 6.64674 4.4707 6.33713 4.4707 5.9552Z"
        fill="#001C12"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.3446 9.64319C5.3446 9.26127 5.63804 8.95166 6.00001 8.95166H11.2433C11.6052 8.95166 11.8987 9.26127 11.8987 9.64319C11.8987 10.0251 11.6052 10.3347 11.2433 10.3347H6.00001C5.63804 10.3347 5.3446 10.0251 5.3446 9.64319Z"
        fill="#001C12"
      />
      <circle cx="15.5156" cy="17.5" r="5.5" fill="white" />
      <path
        d="M14.4929 20.4034V14.7784H15.4474V20.4034H14.4929ZM12.1577 18.0682V17.1136H17.7827V18.0682H12.1577Z"
        fill="black"
      />
    </svg>
  );
};

export const AddOutletIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.63 10.1948V14.1559C2.63 18.1169 4.19352 19.7048 8.0936 19.7048H12.7754C16.6755 19.7048 18.239 18.1169 18.239 14.1559V10.1948"
        stroke="#001C12"
        strokeWidth="1.30293"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4391 10.8829C12.0286 10.8829 13.2013 9.56846 13.0449 7.95406L12.4716 2.06104H8.41517L7.8332 7.95406C7.67685 9.56846 8.84948 10.8829 10.4391 10.8829Z"
        stroke="#001C12"
        strokeWidth="1.30293"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9198 10.8829C17.6744 10.8829 18.96 9.43613 18.7862 7.66294L18.543 5.23692C18.2303 2.94322 17.3617 2.06104 15.0859 2.06104H12.4366L13.0447 8.24518C13.1923 9.70079 14.4866 10.8829 15.9198 10.8829Z"
        stroke="#001C12"
        strokeWidth="1.30293"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.91451 10.8829C6.34773 10.8829 7.64197 9.70079 7.78095 8.24518L7.97204 6.29554L8.38898 2.06104H5.7397C3.46392 2.06104 2.5953 2.94322 2.2826 5.23692L2.04808 7.66294C1.87435 9.43613 3.1599 10.8829 4.91451 10.8829Z"
        stroke="#001C12"
        strokeWidth="1.30293"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.439 15.2939C8.98841 15.2939 8.26746 16.0262 8.26746 17.4994V19.7049H12.6105V17.4994C12.6105 16.0262 11.8896 15.2939 10.439 15.2939Z"
        stroke="#001C12"
        strokeWidth="1.30293"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="16.0156" cy="16" r="5" fill="white" />
      <path
        d="M15.88 19.6058V14.5774H17.1513V19.6058H15.88ZM14.0014 17.7273V16.456H19.0298V17.7273H14.0014Z"
        fill="black"
      />
    </svg>
  );
};

export const EmailEditIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.01562 15.375H5.26562C3.01562 15.375 1.51562 14.25 1.51562 11.625V6.375C1.51562 3.75 3.01562 2.625 5.26562 2.625H12.7656C15.0156 2.625 16.5156 3.75 16.5156 6.375V8.625"
        stroke="#8B97A3"
        strokeWidth="1.4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7656 6.75L10.4181 8.625C9.64562 9.24 8.37812 9.24 7.60562 8.625L5.26562 6.75"
        stroke="#8B97A3"
        strokeWidth="1.4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4239 11.0772L11.7689 13.7322C11.6639 13.8372 11.5664 14.0322 11.5439 14.1747L11.4014 15.1872C11.3489 15.5547 11.6039 15.8097 11.9714 15.7572L12.9839 15.6147C13.1264 15.5922 13.3289 15.4947 13.4264 15.3897L16.0814 12.7347C16.5389 12.2772 16.7564 11.7447 16.0814 11.0697C15.4139 10.4022 14.8814 10.6197 14.4239 11.0772Z"
        stroke="#8B97A3"
        strokeWidth="1.4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.04 11.46C14.265 12.27 14.895 12.9 15.705 13.125"
        stroke="#8B97A3"
        strokeWidth="1.4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LockIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="stroke"
    >
      <g clipPath="url(#clip0_2562_5877)">
        <path
          d="M3.47765 14.1747C3.64339 15.4057 4.66302 16.3701 5.90381 16.4272C6.94788 16.4751 8.00847 16.5002 9.17642 16.5002C10.3444 16.5002 11.405 16.4751 12.449 16.4272C13.6898 16.3701 14.7094 15.4057 14.8752 14.1747C14.9834 13.3713 15.0726 12.548 15.0726 11.7096C15.0726 10.8711 14.9834 10.0478 14.8752 9.24443C14.7094 8.01343 13.6898 7.04902 12.449 6.99198C11.405 6.94398 10.3444 6.91895 9.17642 6.91895C8.00847 6.91895 6.94788 6.94398 5.90381 6.99198C4.66301 7.04902 3.64339 8.01343 3.47765 9.24443C3.36949 10.0478 3.28027 10.8711 3.28027 11.7096C3.28027 12.548 3.36949 13.3713 3.47765 14.1747Z"
          strokeWidth="1.65829"
        />
        <path
          d="M5.85938 6.91889V5.07635C5.85938 3.24465 7.34426 1.75977 9.17596 1.75977C11.0077 1.75977 12.4925 3.24465 12.4925 5.07635V6.91889"
          strokeWidth="1.65829"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.17383 11.71H9.18045"
          strokeWidth="2.21106"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2562_5877">
          <rect
            width="17.6884"
            height="17.6884"
            fill="white"
            transform="translate(0.332031 0.286133)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EmailSearchIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.01562 15.375H5.26562C3.01562 15.375 1.51562 14.25 1.51562 11.625V6.375C1.51562 3.75 3.01562 2.625 5.26562 2.625H12.7656C15.0156 2.625 16.5156 3.75 16.5156 6.375V8.625"
        stroke="#8B97A3"
        strokeWidth="1.4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7656 6.75L10.4181 8.625C9.64562 9.24 8.37812 9.24 7.60562 8.625L5.26562 6.75"
        stroke="#8B97A3"
        strokeWidth="1.4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6656 16.05C14.9911 16.05 16.0656 14.9755 16.0656 13.65C16.0656 12.3245 14.9911 11.25 13.6656 11.25C12.3402 11.25 11.2656 12.3245 11.2656 13.65C11.2656 14.9755 12.3402 16.05 13.6656 16.05Z"
        stroke="#8B97A3"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5156 16.5L15.7656 15.75"
        stroke="#8B97A3"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LinkIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5274 14.6949L18.3949 13.9669C20.13 12.511 20.3641 9.89631 18.9033 8.15548C17.4474 6.42039 14.8327 6.18631 13.0919 7.64704L12.2244 8.375"
        stroke="#8B97A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.78614 11.2601L7.92434 11.9833C6.1835 13.444 5.95517 16.0539 7.4159 17.7947C8.87182 19.5298 11.4865 19.7639 13.2273 18.3031L14.0891 17.58"
        stroke="#8B97A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8629 14.9023L15.4592 11.0456"
        stroke="#8B97A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MerchantIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0001 7.32993C17.9401 7.31993 17.8701 7.31993 17.8101 7.32993C16.4301 7.27993 15.3301 6.14992 15.3301 4.74992C15.3301 3.31992 16.4801 2.16992 17.9101 2.16992C19.3401 2.16992 20.4901 3.32992 20.4901 4.74992C20.4801 6.14992 19.3801 7.27993 18.0001 7.32993Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9714 14.6101C18.3414 14.8401 19.8514 14.6001 20.9114 13.8901C22.3214 12.9501 22.3214 11.4101 20.9114 10.4701C19.8414 9.76008 18.3114 9.52008 16.9414 9.76008"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.97047 7.32993C6.03047 7.31993 6.10047 7.31993 6.16047 7.32993C7.54047 7.27993 8.64047 6.14992 8.64047 4.74992C8.64047 3.31992 7.49047 2.16992 6.06047 2.16992C4.63047 2.16992 3.48047 3.32992 3.48047 4.74992C3.49047 6.14992 4.59047 7.27993 5.97047 7.32993Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.0014 14.6101C5.6314 14.8401 4.12141 14.6001 3.06141 13.8901C1.65141 12.9501 1.65141 11.4101 3.06141 10.4701C4.13141 9.76008 5.6614 9.52008 7.0314 9.76008"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9981 14.8006C11.9381 14.7906 11.8681 14.7906 11.8081 14.8006C10.4281 14.7506 9.32812 13.6206 9.32812 12.2206C9.32812 10.7906 10.4781 9.64062 11.9081 9.64062C13.3381 9.64062 14.4881 10.8006 14.4881 12.2206C14.4781 13.6206 13.3781 14.7606 11.9981 14.8006Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.08875 17.9512C7.67875 18.8912 7.67875 20.4312 9.08875 21.3712C10.6888 22.4412 13.3087 22.4412 14.9087 21.3712C16.3187 20.4312 16.3187 18.8912 14.9087 17.9512C13.3187 16.8913 10.6888 16.8913 9.08875 17.9512Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PartnerIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0008 22.1704H16.0008C20.0208 22.1704 20.7408 20.5604 20.9508 18.6004L21.7008 10.6004C21.9708 8.16041 21.2708 6.17041 17.0008 6.17041H7.0008C2.7308 6.17041 2.0308 8.16041 2.3008 10.6004L3.0508 18.6004C3.2608 20.5604 3.9808 22.1704 8.0008 22.1704Z"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6.17041V5.37041C8 3.60041 8 2.17041 11.2 2.17041H12.8C16 2.17041 16 3.60041 16 5.37041V6.17041"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 13.1704V14.1704C14 14.1804 14 14.1804 14 14.1904C14 15.2804 13.99 16.1704 12 16.1704C10.02 16.1704 10 15.2904 10 14.2004V13.1704C10 12.1704 10 12.1704 11 12.1704H13C14 12.1704 14 12.1704 14 13.1704Z"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.65 11.1704C19.34 12.8504 16.7 13.8504 14 14.1904"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.61914 11.4404C4.86914 12.9804 7.40914 13.9104 9.99914 14.2004"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SendNotificationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="stroke"
    >
      <path
        d="M12.0007 8.29102V2.54102L10.084 4.45768"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 2.54102L13.9167 4.45768"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.20833 12.125C3.375 12.125 3.375 13.8404 3.375 15.9583V16.9167C3.375 19.5617 3.375 21.7083 8.16667 21.7083H15.8333C19.6667 21.7083 20.625 19.5617 20.625 16.9167V15.9583C20.625 13.8404 20.625 12.125 16.7917 12.125C15.8333 12.125 15.565 12.3263 15.0667 12.7L14.0892 13.735C12.9583 14.9425 11.0417 14.9425 9.90125 13.735L8.93333 12.7C8.435 12.3263 8.16667 12.125 7.20833 12.125Z"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.29102 12.1238V10.2071C5.29102 8.28086 5.29102 6.69003 8.16602 6.41211"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.709 12.1238V10.2071C18.709 8.28086 18.709 6.69003 15.834 6.41211"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DangerIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7585 15.92L15.3585 4.4C14.4985 2.85 13.3085 2 11.9985 2C10.6885 2 9.49851 2.85 8.63851 4.4L2.23851 15.92C1.42851 17.39 1.33851 18.8 1.98851 19.91C2.63851 21.02 3.91851 21.63 5.59851 21.63H18.3985C20.0785 21.63 21.3585 21.02 22.0085 19.91C22.6585 18.8 22.5685 17.38 21.7585 15.92ZM11.2485 9C11.2485 8.59 11.5885 8.25 11.9985 8.25C12.4085 8.25 12.7485 8.59 12.7485 9V14C12.7485 14.41 12.4085 14.75 11.9985 14.75C11.5885 14.75 11.2485 14.41 11.2485 14V9ZM12.7085 17.71C12.6585 17.75 12.6085 17.79 12.5585 17.83C12.4985 17.87 12.4385 17.9 12.3785 17.92C12.3185 17.95 12.2585 17.97 12.1885 17.98C12.1285 17.99 12.0585 18 11.9985 18C11.9385 18 11.8685 17.99 11.7985 17.98C11.7385 17.97 11.6785 17.95 11.6185 17.92C11.5585 17.9 11.4985 17.87 11.4385 17.83C11.3885 17.79 11.3385 17.75 11.2885 17.71C11.1085 17.52 10.9985 17.26 10.9985 17C10.9985 16.74 11.1085 16.48 11.2885 16.29C11.3385 16.25 11.3885 16.21 11.4385 16.17C11.4985 16.13 11.5585 16.1 11.6185 16.08C11.6785 16.05 11.7385 16.03 11.7985 16.02C11.9285 15.99 12.0685 15.99 12.1885 16.02C12.2585 16.03 12.3185 16.05 12.3785 16.08C12.4385 16.1 12.4985 16.13 12.5585 16.17C12.6085 16.21 12.6585 16.25 12.7085 16.29C12.8885 16.48 12.9985 16.74 12.9985 17C12.9985 17.26 12.8885 17.52 12.7085 17.71Z"
        fill="#FF392B"
      />
    </svg>
  );
};

export const WarningIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM11.25 8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75C11.59 13.75 11.25 13.41 11.25 13V8ZM12.92 16.38C12.87 16.51 12.8 16.61 12.71 16.71C12.61 16.8 12.5 16.87 12.38 16.92C12.26 16.97 12.13 17 12 17C11.87 17 11.74 16.97 11.62 16.92C11.5 16.87 11.39 16.8 11.29 16.71C11.2 16.61 11.13 16.51 11.08 16.38C11.03 16.26 11 16.13 11 16C11 15.87 11.03 15.74 11.08 15.62C11.13 15.5 11.2 15.39 11.29 15.29C11.39 15.2 11.5 15.13 11.62 15.08C11.86 14.98 12.14 14.98 12.38 15.08C12.5 15.13 12.61 15.2 12.71 15.29C12.8 15.39 12.87 15.5 12.92 15.62C12.97 15.74 13 15.87 13 16C13 16.13 12.97 16.26 12.92 16.38Z"
        fill="#FDE150"
      />
    </svg>
  );
};

export const ImportantIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5589 10.7401L20.2089 9.16008C19.9589 8.86008 19.7489 8.30008 19.7489 7.90008V6.20008C19.7489 5.14008 18.8789 4.27008 17.8189 4.27008H16.1189C15.7189 4.27008 15.1489 4.06008 14.8489 3.81008L13.2689 2.46008C12.5789 1.87008 11.4489 1.87008 10.7589 2.46008L9.15891 3.81008C8.85891 4.06008 8.29891 4.27008 7.89891 4.27008H6.16891C5.10891 4.27008 4.23891 5.14008 4.23891 6.20008V7.90008C4.23891 8.29008 4.03891 8.85008 3.78891 9.15008L2.43891 10.7401C1.85891 11.4401 1.85891 12.5601 2.43891 13.2401L3.78891 14.8301C4.03891 15.1201 4.23891 15.6901 4.23891 16.0801V17.7901C4.23891 18.8501 5.10891 19.7201 6.16891 19.7201H7.90891C8.29891 19.7201 8.86891 19.9301 9.16891 20.1801L10.7489 21.5301C11.4389 22.1201 12.5689 22.1201 13.2589 21.5301L14.8389 20.1801C15.1389 19.9301 15.6989 19.7201 16.0989 19.7201H17.7989C18.8589 19.7201 19.7289 18.8501 19.7289 17.7901V16.0901C19.7289 15.6901 19.9389 15.1301 20.1889 14.8301L21.5389 13.2501C22.1489 12.5701 22.1489 11.4401 21.5589 10.7401ZM11.2489 8.13008C11.2489 7.72008 11.5889 7.38008 11.9989 7.38008C12.4089 7.38008 12.7489 7.72008 12.7489 8.13008V12.9601C12.7489 13.3701 12.4089 13.7101 11.9989 13.7101C11.5889 13.7101 11.2489 13.3701 11.2489 12.9601V8.13008ZM11.9989 16.8701C11.4489 16.8701 10.9989 16.4201 10.9989 15.8701C10.9989 15.3201 11.4389 14.8701 11.9989 14.8701C12.5489 14.8701 12.9989 15.3201 12.9989 15.8701C12.9989 16.4201 12.5589 16.8701 11.9989 16.8701Z"
        fill="#007AFF"
      />
    </svg>
  );
};

export const UpdateIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM6.6 11.23C6.77 10.04 7.3 8.97 8.13 8.13C10.13 6.14 13.28 6.03 15.42 7.77V6.82C15.42 6.41 15.76 6.07 16.17 6.07C16.58 6.07 16.92 6.41 16.92 6.82V9.49C16.92 9.9 16.58 10.24 16.17 10.24H13.5C13.09 10.24 12.75 9.9 12.75 9.49C12.75 9.08 13.09 8.74 13.5 8.74H14.25C12.7 7.66 10.56 7.81 9.18 9.19C8.58 9.79 8.2 10.57 8.07 11.44C8.02 11.81 7.7 12.08 7.33 12.08C7.29 12.08 7.26 12.08 7.22 12.07C6.83 12.02 6.54 11.64 6.6 11.23ZM15.87 15.87C14.8 16.94 13.4 17.47 12 17.47C10.78 17.47 9.57 17.04 8.57 16.23V17.17C8.57 17.58 8.23 17.92 7.82 17.92C7.41 17.92 7.07 17.58 7.07 17.17V14.5C7.07 14.09 7.41 13.75 7.82 13.75H10.49C10.9 13.75 11.24 14.09 11.24 14.5C11.24 14.91 10.9 15.25 10.49 15.25H9.74C11.29 16.33 13.43 16.18 14.81 14.8C15.41 14.2 15.79 13.42 15.92 12.55C15.98 12.14 16.35 11.85 16.77 11.91C17.18 11.97 17.46 12.35 17.41 12.76C17.23 13.97 16.7 15.04 15.87 15.87Z"
        fill="#00E6A0"
      />
    </svg>
  );
};

export const TextIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#8B97A3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 8.89039C10.15 7.32039 13.85 7.32039 17 8.89039"
        stroke="#8B97A3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16.2997V7.92969"
        stroke="#8B97A3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AttachmentIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.778 8.49377C18.2338 7.038 18.2338 4.67773 16.778 3.22196C15.3223 1.76619 12.962 1.76619 11.5062 3.22196L3.22196 11.5062C1.76619 12.962 1.76619 15.3223 3.22196 16.778C4.67773 18.2338 7.038 18.2338 8.49377 16.778L12.8242 12.4476C13.3441 11.9277 13.3441 11.0848 12.8242 10.5648C12.3043 10.0449 11.4613 10.0449 10.9414 10.5648L6.98754 14.5187C6.5716 14.9346 5.89724 14.9346 5.48131 14.5187C5.06537 14.1028 5.06537 13.4284 5.48131 13.0125L9.43516 9.05861C10.7869 7.70682 12.9786 7.70682 14.3304 9.05861C15.6822 10.4104 15.6822 12.6021 14.3304 13.9539L10 18.2843C7.71236 20.5719 4.00337 20.5719 1.71573 18.2843C-0.571908 15.9966 -0.571908 12.2876 1.71573 10L10 1.71573C12.2876 -0.57191 15.9966 -0.57191 18.2843 1.71573C20.5719 4.00337 20.5719 7.71236 18.2843 10L17.9078 10.3765C17.4918 10.7924 16.8174 10.7925 16.4015 10.3766C15.9855 9.96062 15.9855 9.28626 16.4015 8.87033L16.778 8.49377Z"
        fill="#8B97A3"
      />
    </svg>
  );
};

export const ImageIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#8B97A3"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
        stroke="#8B97A3"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66992 18.9505L7.59992 15.6405C8.38992 15.1105 9.52992 15.1705 10.2399 15.7805L10.5699 16.0705C11.3499 16.7405 12.6099 16.7405 13.3899 16.0705L17.5499 12.5005C18.3299 11.8305 19.5899 11.8305 20.3699 12.5005L21.9999 13.9005"
        stroke="#8B97A3"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotificationIcon = ({ color = "#8B97A3" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clip-rule="evenodd"
        d="M9.6191 1.51953C6.50567 1.51953 3.98173 4.04347 3.98173 7.1569V9.09493C3.98173 10.114 3.32505 11.0052 2.8031 11.8805C2.52872 12.3406 2.37109 12.8784 2.37109 13.453C2.37109 14.9375 3.43171 16.2111 4.90215 16.415C6.36238 16.6175 8.187 16.8212 9.61914 16.8212C11.0513 16.8212 12.8759 16.6175 14.3361 16.415C15.8066 16.2111 16.8672 14.9375 16.8672 13.453C16.8672 12.8783 16.7095 12.3405 16.4352 11.8805C15.9132 11.0052 15.2565 10.1139 15.2565 9.09483V7.1569C15.2565 4.04347 12.7325 1.51953 9.6191 1.51953Z"
        fill={color}
      />
      <path
        stroke={color}
        d="M2.37109 13.453H3.0657H2.37109ZM4.90215 16.415L4.80675 17.103H4.80675L4.90215 16.415ZM14.3361 16.415L14.2407 15.727L14.3361 16.415ZM16.4352 11.8805L15.8386 12.2362L16.4352 11.8805ZM2.8031 11.8805L2.20652 11.5247L2.8031 11.8805ZM4.67633 7.1569C4.67633 4.42709 6.88929 2.21414 9.6191 2.21414V0.824927C6.12205 0.824927 3.28713 3.65985 3.28713 7.1569H4.67633ZM4.67633 9.09493V7.1569H3.28713V9.09493H4.67633ZM3.0657 13.453C3.0657 13.007 3.18767 12.5917 3.39967 12.2363L2.20652 11.5247C1.86977 12.0894 1.67649 12.7497 1.67649 13.453H3.0657ZM4.99755 15.727C3.88652 15.5729 3.0657 14.6071 3.0657 13.453H1.67649C1.67649 15.2679 2.97689 16.8493 4.80675 17.103L4.99755 15.727ZM9.61914 16.1266C8.23736 16.1266 6.45214 15.9287 4.99755 15.727L4.80675 17.103C6.27262 17.3063 8.13665 17.5158 9.61914 17.5158V16.1266ZM14.2407 15.727C12.7861 15.9287 11.0009 16.1266 9.61914 16.1266V17.5158C11.1016 17.5158 12.9657 17.3063 14.4315 17.103L14.2407 15.727ZM16.1726 13.453C16.1726 14.6071 15.3518 15.5729 14.2407 15.727L14.4315 17.103C16.2614 16.8493 17.5618 15.2679 17.5618 13.453H16.1726ZM15.8386 12.2362C16.0506 12.5917 16.1726 13.007 16.1726 13.453H17.5618C17.5618 12.7496 17.3685 12.0894 17.0317 11.5247L15.8386 12.2362ZM14.5619 7.1569V9.09483H15.9511V7.1569H14.5619ZM9.6191 2.21414C12.3489 2.21414 14.5619 4.42709 14.5619 7.1569H15.9511C15.9511 3.65985 13.1162 0.824927 9.6191 0.824927V2.21414ZM17.0317 11.5247C16.7456 11.045 16.4858 10.6606 16.2716 10.2314C16.0664 9.82036 15.9511 9.45371 15.9511 9.09483H14.5619C14.5619 9.75504 14.7749 10.3436 15.0286 10.8518C15.2732 11.3418 15.6027 11.8407 15.8386 12.2362L17.0317 11.5247ZM3.28713 9.09493C3.28713 9.4538 3.17181 9.82044 2.96666 10.2314C2.75241 10.6606 2.49259 11.045 2.20652 11.5247L3.39967 12.2363C3.63555 11.8407 3.96505 11.3418 4.20963 10.8519C4.46331 10.3436 4.67633 9.75512 4.67633 9.09493H3.28713Z"
        fill={color}
      />
      <path
        d="M11.6328 18.9629C11.2 19.6139 10.4598 20.0429 9.61947 20.0429C8.77911 20.0429 8.03897 19.6139 7.60613 18.9629"
        stroke={color}
        strokeWidth="1.38921"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const StarIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4265 2.92617L13.8931 5.85951C14.0931 6.26784 14.6265 6.65951 15.0765 6.73451L17.7348 7.17617C19.4348 7.45951 19.8348 8.69284 18.6098 9.9095L16.5431 11.9762C16.1931 12.3262 16.0015 13.0012 16.1098 13.4845L16.7015 16.0428C17.1681 18.0678 16.0931 18.8512 14.3015 17.7928L11.8098 16.3178C11.3598 16.0512 10.6181 16.0512 10.1598 16.3178L7.66812 17.7928C5.88479 18.8512 4.80145 18.0595 5.26812 16.0428L5.85979 13.4845C5.96812 13.0012 5.77645 12.3262 5.42645 11.9762L3.35979 9.9095C2.14312 8.69284 2.53479 7.45951 4.23479 7.17617L6.89312 6.73451C7.33479 6.65951 7.86812 6.26784 8.06812 5.85951L9.53479 2.92617C10.3348 1.33451 11.6348 1.33451 12.4265 2.92617Z"
        fill="#8E95A9"
      />
    </svg>
  );
};
export const FwdIcon = () => {
  return (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3751 5.14283L7.32244 0.925977L8.96418 5.15159C1.195 9.38596 -0.258372 16.03 0.625291 21.766C2.11006 16.9336 5.54317 13.6543 11.3858 11.3844L13.0685 15.7156L18.3751 5.14283Z"
        fill="#8E95A9"
      />
    </svg>
  );
};
export const CopyIcon2 = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6512 11.8249V15.6749C15.6512 18.8833 14.3679 20.1666 11.1595 20.1666H7.30954C4.1012 20.1666 2.81787 18.8833 2.81787 15.6749V11.8249C2.81787 8.61658 4.1012 7.33325 7.30954 7.33325H11.1595C14.3679 7.33325 15.6512 8.61658 15.6512 11.8249Z"
        fill="#8E95A9"
      />
      <path
        d="M16.6592 1.83325H12.8092C10.0157 1.83325 8.6884 2.81311 8.39142 5.17717C8.32201 5.72974 8.78165 6.18742 9.33856 6.18742H11.1592C15.0092 6.18742 16.7967 7.97492 16.7967 11.8249V13.6455C16.7967 14.2024 17.2543 14.6621 17.8069 14.5927C20.171 14.2957 21.1508 12.9684 21.1508 10.1749V6.32492C21.1508 3.11659 19.8675 1.83325 16.6592 1.83325Z"
        fill="#8E95A9"
      />
    </svg>
  );
};

export const AttachIcon = ({ color }: any) => {
  return (
    <svg
      height="20px"
      width="20px"
      version="1.1"
      id="Layer_1"
      viewBox="0 0 280.067 280.067"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <path
            style={{ fill: `${color}` }}
            d="M149.823,257.142c-31.398,30.698-81.882,30.576-113.105-0.429 c-31.214-30.987-31.337-81.129-0.42-112.308l-0.026-0.018L149.841,31.615l14.203-14.098c23.522-23.356,61.65-23.356,85.172,0 s23.522,61.221,0,84.586l-125.19,123.02l-0.044-0.035c-15.428,14.771-40.018,14.666-55.262-0.394 c-15.244-15.069-15.34-39.361-0.394-54.588l-0.044-0.053l13.94-13.756l69.701-68.843l13.931,13.774l-83.632,82.599 c-7.701,7.596-7.701,19.926,0,27.53s20.188,7.604,27.88,0L235.02,87.987l-0.035-0.026l0.473-0.403 c15.682-15.568,15.682-40.823,0-56.39s-41.094-15.568-56.776,0l-0.42,0.473l-0.026-0.018l-14.194,14.089L50.466,158.485 c-23.522,23.356-23.522,61.221,0,84.577s61.659,23.356,85.163,0l99.375-98.675l14.194-14.089l14.194,14.089l-14.194,14.098 l-99.357,98.675C149.841,257.159,149.823,257.142,149.823,257.142z"
          ></path>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export const TrueSign = ({ color, height, width, viewBox }: any) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14.6939" cy="14.6939" r="14.6939" fill={color} />
      <path
        d="M8.81628 14.7507L12.5466 18.481L20.0204 11.0204"
        stroke="white"
        strokeWidth="1.97719"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ThemeIcon = ({
  color = "#3A3A3A",
  height,
  width = "18",
  viewBox = "0 0 18 17",
}: any) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6681_6667)">
        <path
          d="M8.40869 1.96289H7.04183C3.62467 1.96289 2.25781 3.32975 2.25781 6.74691V10.8475C2.25781 14.2646 3.62467 15.6315 7.04183 15.6315H11.1424C14.5596 15.6315 15.9264 14.2646 15.9264 10.8475V9.48063"
          stroke="#3A3A3A"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8652 3.02919C15.0245 5.12733 12.9127 7.98407 11.1495 9.39877L10.0697 10.2599C9.93298 10.3624 9.7963 10.4444 9.63911 10.5059C9.63911 10.4034 9.63227 10.3009 9.6186 10.1916C9.55709 9.73365 9.35207 9.30309 8.98301 8.94087C8.60713 8.56498 8.15606 8.35312 7.69133 8.29161C7.58198 8.28478 7.47263 8.27794 7.36328 8.28478C7.42479 8.11392 7.51364 7.95673 7.62982 7.82688L8.49094 6.74706C9.90565 4.98381 12.7692 2.85834 14.8605 2.01772C15.1817 1.8947 15.4961 1.99038 15.6943 2.18857C15.8993 2.3936 15.995 2.70798 15.8652 3.02919Z"
          stroke="#3A3A3A"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.64381 10.5013C9.64381 11.1027 9.41145 11.6768 8.98089 12.1142C8.64601 12.4491 8.19494 12.6815 7.65503 12.7498L6.30867 12.8933C5.5774 12.9753 4.94864 12.3534 5.03066 11.6085L5.17418 10.2621C5.30403 9.06612 6.30184 8.30068 7.36799 8.28017C7.47734 8.27334 7.58669 8.28017 7.69604 8.28701C8.16077 8.34852 8.61183 8.56038 8.98772 8.93627C9.35677 9.30532 9.5618 9.72905 9.62331 10.1869C9.63698 10.2963 9.64381 10.4056 9.64381 10.5013Z"
          stroke="#3A3A3A"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.723 8.78552C11.723 7.35715 10.568 6.19531 9.13281 6.19531"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6681_6667">
          <rect
            width="16.4023"
            height="16.4023"
            fill="white"
            transform="translate(0.910156 0.597656)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GalleryIcon = ({
  color = "#3A3A3A",
  height,
  width = "18",
  viewBox = "0 0 18 17",
}: any) => {
  return (
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.72639 16.5821H12.849C17.1179 16.5821 18.8254 15.0747 18.8254 11.3061V6.78382C18.8254 3.01524 17.1179 1.50781 12.849 1.50781H7.72639C3.45754 1.50781 1.75 3.01524 1.75 6.78382V11.3061C1.75 15.0747 3.45754 16.5821 7.72639 16.5821Z"
        stroke="#001C12"
        strokeWidth="1.39607"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.72707 7.5383C8.67012 7.5383 9.43461 6.8634 9.43461 6.03087C9.43461 5.19834 8.67012 4.52344 7.72707 4.52344C6.78402 4.52344 6.01953 5.19834 6.01953 6.03087C6.01953 6.8634 6.78402 7.5383 7.72707 7.5383Z"
        stroke="#001C12"
        strokeWidth="1.39607"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.32031 14.2832L6.5294 11.7884C7.20387 11.3889 8.17717 11.4341 8.78335 11.8939L9.06509 12.1125C9.73103 12.6175 10.8068 12.6175 11.4727 12.1125L15.0244 9.42171C15.6903 8.91672 16.7661 8.91672 17.432 9.42171L18.8237 10.4769"
        stroke="#001C12"
        strokeWidth="1.39607"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ColorPickerIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.35 11.7205L17.22 13.8505L15.81 12.4305L8.1 20.1405L3.5 22.0005L2 20.5005L3.86 15.9005L11.57 8.19055L10.15 6.78055L12.28 4.65055L19.35 11.7205ZM16.76 3.00055C17.93 1.83055 19.83 1.83055 21 3.00055C22.17 4.17055 22.17 6.07055 21 7.24055L19.08 9.16055L14.84 4.92055L16.76 3.00055ZM5.56 17.0305L4.5 19.5005L6.97 18.4405L14.4 11.0005L13 9.60055L5.56 17.0305Z"
        fill="#8B97A3"
      />
    </svg>
  );
};

export const ChartIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 2.99905H5.5V12.9991H9.5V6.99905H13.5V10.9991H17.5V14.9991H21.5V20.9991H3.5V2.99905Z"
        fill="#00E6A0"
      />
    </svg>
  );
};
